export default {
    address: {
        city: "Stadt",
        city_locality: "Stadt \/ Ort",
        country: "Land",
        line1: "Adresszeile 1",
        line2: "Adresszeile 2",
        postal_code: "Postleitzahl",
        state: "Bundesland",
        state_region: "Bundesland\/Region"
    },
    alerts: {
        account_2fa: "Sichern Sie Ihr Konto mit der Zwei-Faktor-Authentifizierung.",
        account_2fa_success: "Die Zwei-Faktor-Authentifizierung ist aktiviert.",
        activate_instruction: "Wenn Sie die automatische Bewertungserfassung aktivieren, wird versucht, eine Bewertung von {count} anzufordern. Sehen Sie sich vor der Aktivierung Ihre Vorlagen an.",
        activate_intro: "Fordern Sie basierend auf Ihrer Strategie kontinuierlich Bewertungen an.",
        agency_mcp_server: "Verbinden Sie Claude oder einen beliebigen MCP Client mit dem MCP Server Ihrer Agentur. Autorisierte Assistenten können in Ihrem Namen die Projekte, Clients und das Team Ihrer Agentur verwalten.",
        agency_sso: "Verbinden Sie einen OpenID Connect-Identitätsanbieter für die Clientanmeldung.",
        ai_assistant: "Um KI für Bewertungsvorschläge und Antworten nutzen zu können, sind Ihr Firmenname und Ihre Beschreibung erforderlich.",
        ai_location_instructions: "Wird zu den benutzerdefinierten Anweisungen oben hinzugefügt und nur für den ausgewählten Standort verwendet.",
        ai_review_pages: "Erlauben Sie KI-Bewertungsvorschläge auf den ausgewählten Seiten.",
        api_key_roll: "Sind Sie sicher, dass Sie Ihren API Schlüssel ändern möchten? Dies wird Auswirkungen auf alle Anwendungen haben, die ihn verwenden.",
        ask_confirm: "Möchten Sie wirklich Bewertungen von {count} anfordern? Dadurch werden Anfragen für alle Kunden geplant, die noch nicht angefragt wurden.",
        automate_highlights: "Heben Sie Phrasen in neuen positiven Bewertungen automatisch hervor.",
        automate_replies: "Veröffentlichen Sie KI-Antworten automatisch auf neuen Google- und Facebook-Bewertungen. Erfordert eine [Google- oder Facebook-Integration](\/settings\/integrations?tab=review).",
        cname_delete: "Möchten Sie den CNAME: {cname_name} wirklich entfernen?",
        cname_not_configured: "Dieser Datensatz wurde noch nicht konfiguriert. Bitte warten...",
        cname_warning: "Nachrichten, die bereits an Ihre Kunden gesendet wurden, enthalten defekte Links.",
        connection_disabled: "Die Verbindung ist deaktiviert. Bitte stellen Sie die Verbindung erneut her.",
        customer_archive: "Möchten Sie den Kunden {customer_name} wirklich archivieren? Alle nicht gesendeten Nachrichten werden storniert.",
        customer_cancel: "Möchten Sie wirklich alle nicht gesendeten Nachrichten für den Kunden {customer_name} stornieren?",
        customer_ingest: "Fügen Sie diese E-Mail-Adresse in das BCC-Feld ein, wenn Sie E-Mails an Ihre Kunden senden, damit deren Name und E-Mail-Adresse automatisch importiert werden.",
        customer_resubscribe: "Möchten Sie den Kunden {customer_name} wirklich erneut abonnieren?",
        customer_unarchive: "Möchten Sie den Kunden: {customer_name} wirklich aus dem Archiv holen?",
        customer_unsubscribe: "Möchten Sie den Kunden: {customer_name} wirklich abbestellen?",
        customer_unsubscribe_all: "Möchten Sie {count} wirklich vom Empfang von Nachrichten aus diesem Projekt abmelden?",
        delete: "Möchten Sie {model}:{name} wirklich löschen?",
        delete_count: "Möchten Sie {count} wirklich löschen?",
        domain_agency: "Fügen Sie Ihre eigene Sendedomäne hinzu, um Ihre Agentur vollständig als White Label zu kennzeichnen.",
        domain_delete: "Möchten Sie die Domäne wirklich entfernen: {name}? Wir werden weiterhin E-Mails von unserem eigenen Domänennamen senden.",
        domain_dmarc: "Fügen Sie Ihrer Domain einen DMARC Eintrag hinzu, um die Wahrscheinlichkeit zu verringern, dass E-Mails im Spam-Ordner landen.",
        domain_project: "Fügen Sie eine Sendedomäne hinzu, damit wir Ihren Kunden von Ihrem eigenen Domänennamen aus E-Mails senden können.",
        export_confirm: "Möchten Sie wirklich alle Ihre {model} exportieren?",
        export_count: "Möchten Sie {count} wirklich exportieren?",
        export_link: "Kurz nach Ihrer Anfrage wird ein Download-Link an {email} gesendet.",
        highlights_save_disabled: "Optional können Sie Hervorhebungen aus allen Bewertungen entfernen, die derzeit welche enthalten.",
        highlights_save_enabled: "Um alle positiven Bewertungen hervorzuheben, aktivieren Sie das Kontrollkästchen unten. Wenn Sie nur die Hervorhebungsfarbe ändern möchten, lassen Sie das Kontrollkästchen deaktiviert.",
        integration_disconnect: "Möchten Sie die Verbindung zu {integration_name} wirklich trennen?",
        integration_sync: "Möchten Sie Ihr {integration_name}-Konto wirklich synchronisieren? Wir importieren Ihre Daten fortlaufend für Sie.",
        intro: "Importieren Sie zuerst Ihre Kunden. Dann senden Sie Bewertungsanfragen selbst, oder wir senden sie für Sie.",
        intro_help: "Wenn Sie Hilfe brauchen, {demo}.",
        logout: "Möchten Sie sich wirklich abmelden?",
        mcp_server: "Verbinden Sie Claude oder einen beliebigen MCP Client mit diesem Projekt. Der MCP Server ermöglicht es KI-Assistenten, Bewertungen, Kundendaten und Nachrichten in Ihrem Namen zu lesen und zu verwalten.",
        member_confirm: "Möchten Sie sich wirklich entfernen? Sie verlieren dann den Zugriff auf dieses Projekt.",
        member_confirm_all: "Möchten Sie sich wirklich entfernen? Sie verlieren dann den Zugriff auf alle Ihre Projekte.",
        member_other_confirm: "Möchten Sie {noun}: {name} wirklich entfernen? Sie verlieren dann den Zugriff auf dieses Projekt.",
        member_other_confirm_all: "Möchten Sie {noun} {name} wirklich entfernen? Sie verlieren dann den Zugriff auf alle ihre Projekte.",
        message_cancel: "Möchten Sie diese Nachricht wirklich abbrechen?",
        message_cancel_all: "Möchten Sie {count} wirklich abbrechen? Diese Aktion kann nur für nicht gesendete Nachrichten ausgeführt werden.",
        message_delete: "Möchten Sie diese Nachricht wirklich löschen?",
        oauth_client_revoke: "Sind Sie sicher, dass Sie den Zugriff für {client} widerrufen möchten? Alle aktiven Sitzungen werden sofort getrennt.",
        project_summary: "Es kann derzeit keine Zusammenfassung erstellt werden.",
        project_suspend: "Möchten Sie das Projekt wirklich anhalten: {project_name}?",
        project_unsuspend: "Möchten Sie die Aussetzung des Projekts {project_name} wirklich aufheben?",
        review_delete: "Möchten Sie diese Bewertung wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
        review_page_confirm: "Möchten Sie Ihre Änderungen wirklich speichern?",
        review_page_confirmation: "Zeigen Sie auf der Erfolgsseite eine Bestätigungsnachricht basierend auf der ausgewählten Bewertung an.",
        review_page_default: "Möchten Sie die Bewertungsseite: {name} wirklich als Standardseite festlegen? Diese Seite wird verwendet, wenn einer Bewertungsanfrage keine andere Seite zugewiesen ist.",
        review_page_delete: "Möchten Sie die Bewertungsseite wirklich löschen: {name}? Alle Kunden, die derzeit auf diese Seite weitergeleitet werden, werden auf Ihre Standardseite weitergeleitet.",
        review_page_delete_all: "Möchten Sie {count} wirklich löschen? Ihre Standard-Bewertungsseite wird nicht gelöscht.",
        review_page_fields: "Verwenden Sie Felder, um Kundeninformationen zu erfassen, wenn Sie eine Bewertung abgeben. Fügen Sie Ihrem Formular weitere Felder hinzu und zeigen Sie diese unter bestimmten Bedingungen an, wenn Kunden eine Bewertung auswählen.",
        review_page_instructions: "Anweisungen direkt über dem Formular anzeigen, nachdem eine Bewertung ausgewählt wurde.",
        review_page_location_picker: "Lassen Sie Kunden für die Bewertung einen beliebigen Standort in Ihrem Projekt auswählen. Dieser wird vorab ausgewählt, wenn die Bewertungsseite für einen bestimmten Standort angezeigt werden soll.",
        review_page_locations: "Wählen Sie die Standorte aus, die diese Bewertungsseite verwenden sollen. Einem Standort kann nur eine Bewertungsseite zugewiesen werden. Wenn einem Standort keine Bewertungsseite zugewiesen ist, wird die Standardbewertungsseite verwendet.",
        review_page_redirects: "Überspringen Sie das Formular, nachdem Sie eine Bewertung ausgewählt haben, und leiten Sie es an eine andere Stelle weiter. Sie können den Datenverkehr auch auf mehrere Websites aufteilen, indem Sie für jede Bewertung mehr als eine Weiterleitung hinzufügen.",
        review_page_review_suggestions: "Helfen Sie Kunden, Bewertungen mit fertigen Vorschlägen zu schreiben, die sie vor dem Absenden bearbeiten können.",
        selection_all: "Alle {count} Zeilen sind ausgewählt.",
        selection_all_1: "1 Zeile ist ausgewählt.",
        selection_page: "Alle {count} Zeilen auf dieser Seite sind ausgewählt.",
        selection_page_1: "1 Zeile auf dieser Seite ist ausgewählt.",
        share_template_delete: "Möchten Sie die Freigabevorlage \"{name}\" wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.",
        smtp_remove: "Möchten Sie die SMTP -Konfiguration wirklich aus Ihrem Projekt entfernen? Ihre Absenderdomäne wird auf die Standardkonfiguration zurückgesetzt.",
        smtp_setup: "Senden Sie E-Mails von Ihrem eigenen Mailserver. Geben Sie Ihre SMTP Zugangsdaten ein. Falls Ihr Server IP-Beschränkungen verwendet, setzen Sie bitte die folgenden von unserem System verwendeten IPs auf die Whitelist: {ips}.",
        space_delete: "Möchten Sie den Arbeitsbereich wirklich löschen: {name}? Alle darin enthaltenen Projekte werden gelöscht.",
        tag_rule: "Fügen Sie einen positiven Begriff und sein negatives Gegenstück hinzu. Wenn dies zutrifft, verwenden wir KI, um die Bewertung automatisch mit dem einen oder dem anderen zu kennzeichnen.",
        user_delete: "Möchten Sie das Benutzerkonto für: {email} wirklich löschen?",
        user_verify: "Um Ihre E-Mail-Adresse zu bestätigen und Ihr Konto zu aktivieren, klicken Sie auf den Link in der E-Mail, die an {email} gesendet wurde.",
        widget_delete: "Möchten Sie das Widget wirklich löschen: {name}? Das Widget wird auf keiner Website mehr angezeigt.",
        widget_restore: "Möchten Sie die Einstellungen für Widget: {name} wirklich wiederherstellen? Nur das Design wird auf die Standardwerte zurückgesetzt.",
        widgets_1: "Fügen Sie dieses Skript in den Body Ihrer Website ein.",
        widgets_2: "Die Bewertungswand zeigt alle Ihre Bewertungen als Raster an. Fügen Sie dieses Skript überall dort ein, wo das Widget angezeigt werden soll.",
        widgets_3: "Das Bewertungs-Spotlight zeigt eine große Bewertung an. Fügen Sie dieses Skript überall dort ein, wo das Widget angezeigt werden soll."
    },
    billing_statuses: {
        active: "Ihr Abonnement ist aktiv.",
        canceled: "Ihr Abonnement wurde gekündigt. Bitte aktualisieren Sie Ihr Abonnement, um es fortzusetzen.",
        ending: "Ihr Abonnement endet am {date}.",
        trial: "Ihre kostenlose Testphase endet am {date}.",
        trial_expired: "Ihre kostenlose Testphase ist abgelaufen. Bitte führen Sie ein Upgrade durch, um fortzufahren.",
        trial_expiring: "Ihre kostenlose Testphase endet bald. Bitte aktualisieren Sie Ihr Abonnement, um sie fortzusetzen."
    },
    brands: {
        discord: "Discord",
        email: "E-Mail",
        facebook: "Facebook",
        google: "Google",
        google_analytics: "Google Analytics",
        hubspot: "HubSpot",
        linkedin: "LinkedIn",
        make_com: "Make.com",
        messenger: "Messenger",
        pabbly: "Pabbly",
        recaptcha: "reCAPTCHA",
        reddit: "Reddit",
        slack: "Slack",
        stripe: "Stripe",
        threads: "Threads",
        twilio: "Twilio",
        whatsapp: "WhatsApp",
        x: "X",
        zapier: "Zapier"
    },
    captions: {
        add_sending_domain: "Fügen Sie eine Sendedomäne hinzu, um Ihre E-Mail-Adresse zu bearbeiten:",
        agency_robots: "Erlauben Sie Suchmaschinen, Ihr Kundenportal zu indizieren.",
        analytics_average_review: "Durchschnittliche Sternebewertung in diesem Zeitraum.",
        analytics_customers: "Hinzugefügte Kunden und Kunden, die erstmals um eine Bewertung gebeten wurden.",
        analytics_limits: "Bewertungsanfragen heute und in diesem Monat.",
        analytics_location_leaderboard: "Anzahl der Bewertungen, Durchschnittsbewertung und Anteil der 5-Sterne-Bewertungen nach Standort.",
        analytics_needs_attention: "1- und 2-Sterne-Bewertungen der letzten 3 Monate ohne Antwort.",
        analytics_outreach: "Gesendete, angeklickte und fehlgeschlagene Nachrichten im Zeitverlauf.",
        analytics_reply_coverage: "Anteil der Bewertungen mit einer Antwort.",
        analytics_review_velocity: "Durchschnittlich erhaltene Bewertungen pro Woche.",
        analytics_review_volume: "Wie viele Bewertungen Sie in diesem Zeitraum erhalten haben.",
        analytics_sentiment: "Schriftliche Bewertungen, bewertet als positiv, neutral oder negativ.",
        analytics_source_mix: "Anzahl der Bewertungen und Durchschnittsbewertung nach Quelle.",
        analytics_star_mix: "Anzahl der Bewertungen im Zeitverlauf nach Sternebewertung.",
        analytics_tags: "Meistverwendete Tags in diesem Zeitraum, mit Anzahl und Durchschnitt.",
        ai_business_description: "Eine detaillierte Beschreibung Ihres Unternehmens als Hilfestellung für die Erstellung von Bewertungsvorschlägen und Antworten.",
        ai_business_name: "Der Name Ihres Unternehmens.",
        ai_highlights: "Heben Sie die besten Phrasen in Ihren positiven Bewertungen hervor.",
        ai_highlights_instructions: "Sagen Sie der KI, welche Phrasen in Highlights bevorzugt werden sollen.",
        ai_replies: "Entwerfen Sie Antworten auf Ihre Bewertungen und automatisieren Sie sie optional.",
        ai_reply_contact: "Wird in Antworten auf negative Bewertungen aufgenommen.",
        ai_reply_instructions: "Sagen Sie der KI, wie Antworten klingen und was sie enthalten sollen.",
        ai_review_instructions: "Sagen Sie der KI, was in Bewertungsvorschlägen erwähnt oder vermieden werden soll.",
        ai_review_suggestions: "Helfen Sie Kunden mit fertigen Vorschlägen beim Schreiben von Bewertungen.",
        ai_tags: "Markieren Sie Bewertungen automatisch, die zu Ihren Anweisungen passen.",
        ask_location: "Der Ort, der der Bewertung zugewiesen werden soll.",
        ask_review_page: "Die Seite zum Erfassen der Bewertung.",
        assign_tags: "Weisen Sie der Bewertung Tags zu.",
        cname_agency_reviews: "Wird als Bewertungsseite für jedes Projekt angezeigt, es sei denn, das Projekt verfügt über eine eigene Domain.",
        cname_project_override: "Ersetzt die Agenturdomäne nur für dieses Projekt.",
        csv_max_rows: "Bis zu {count} Zeilen",
        dashboard_configure_settings: "Konfigurieren Sie Ihre Projekteinstellungen.",
        dashboard_import_customers: "Importieren Sie Ihre Kunden.",
        dashboard_preview_email_templates: "Zeigen Sie eine Vorschau Ihrer E-Mail-Vorlagen an.",
        dashboard_preview_kiosk_page: "Zeigen Sie eine Vorschau Ihrer Kioskseite an.",
        dashboard_preview_review_page: "Zeigen Sie eine Vorschau Ihrer Bewertungsseite an.",
        dashboard_preview_showcase_page: "Zeigen Sie eine Vorschau Ihrer Showcase-Seite an.",
        detect_from_website: "Lassen Sie dieses Feld leer, damit die Erkennung von der Website übernommen wird.",
        logo_height: "Die Höhe des Logos in E-Mails und auf Seiten.",
        meta_description: "Überschreibt die Seitenbeschreibung.",
        meta_title: "Überschreiben Sie den Seitentitel.",
        mfa_password: "Geben Sie Ihr Kontopasswort ein.",
        mfa_qr_code: "Scannen Sie den QR-Code mit Ihrer Authentifizierungs-App.",
        mfa_security_code: "Geben Sie den Code aus Ihrer Authentifizierungs-App ein.",
        mcp_server_url: "Fügen Sie diese URL in Claude, ChatGPT oder einen beliebigen MCP Client ein.",
        other_website_url: "Anforderungen:<br>Bewertung: 1 bis 5 Sterne<br>Datum: Innerhalb der letzten 2 Jahre<br>Nur öffentliche Seiten",
        override_ambassador: "Zeigen Sie in den E-Mails, Seiten und Widgets Ihrer Clients ein Abzeichen an.",
        project_name: "Der Name Ihres Unternehmens, Ihrer Marke oder Ihrer Website.",
        project_robots: "Erlauben Sie Suchmaschinen, Ihre Bewertungsseiten zu indizieren und zu präsentieren.",
        project_slug: "Wird in E-Mails und Links an Kunden verwendet, wenn kein CNAME konfiguriert ist.",
        qr_fallback_redownload: "Laden Sie den Code erneut herunter, nachdem Sie dies hinzugefügt haben.",
        qr_fallback_url: "Wird verwendet, wenn das Projekt ausgesetzt oder gelöscht wird.",
        review_page_copied_message: "Wird angezeigt, nachdem eine positive Bewertung abgegeben wurde.",
        review_page_email_address: "Erhalten Sie Bewertungen per E-Mail.",
        review_page_link_reveal_position: "Wo die Links angezeigt werden.",
        review_page_link_revealer_label: "Das Label zum Anzeigen der Links.",
        review_page_link_revealer_rating: "Zeigen Sie Links an, wenn der Kunde diese oder eine höhere Bewertung auswählt. Andernfalls wird eine Schaltfläche zum Anzeigen der Links angezeigt.",
        review_page_native_reviews: "Erlauben Sie Bewertungen auf dieser Plattform.",
        review_page_rating_selection: "Bewertung speichern bevor eine Bewertung abgegeben wird.",
        review_page_success_button_link: "Wenn dieses Feld leer ist, wird der Link standardmäßig zu Ihrer Projektwebsite geführt, andernfalls zur Domäne der Seite.",
        review_page_warning: "Wenn Sie Kunden daran hindern, öffentliche Bewertungen zu hinterlassen, kann dies zur Entfernung Ihres Firmeneintrags führen.",
        review_reply_status: "Wir können auf diese Bewertung nicht öffentlich antworten. Sie können stattdessen direkt Kontakt mit dem Rezensent aufnehmen.",
        scrape_facebook_url: "Anforderungen:<br>Bis zu 100 aktuelle Bewertungen<br>Nur öffentliche Seiten",
        scrape_linkedin_url: "Anforderungen:<br>Nur Empfehlungen<br>Nur öffentliche Seiten",
        scrape_trustpilot_url: "Anforderungen:<br>Bewertung: 1 bis 5 Sterne<br>Nur öffentliche Seiten",
        separate_with_commas: "Mehrere durch Kommas trennen.",
        setup_basics: "Legen Sie fest, wann und wie Sie Kunden um Bewertungen bitten.",
        setup_business: "Nennen Sie uns den Namen, unter dem Ihre Kunden Sie kennen.",
        setup_google: "Leiten Sie Kunden zu Ihrem Google Profil weiter, beantworten Sie Bewertungen und importieren Sie bestehende Rezensionen. Sie können diesen Schritt auch überspringen und später erledigen.",
        setup_location_limit: "Ihre Testversion umfasst 1 Standort. Sie können jederzeit upgraden, um weitere Standorte zu synchronisieren.",
        showcase_locations: "Beschränken Sie die Präsentation auf bestimmte Standorte.",
        showcase_review_length: "Bewertungen müssen mindestens diese Anzahl Zeichen lang sein.",
        showcase_since: "Bewertungen anzeigen, die an oder vor diesem Datum erstellt wurden.",
        showcase_sources: "Beschränken Sie die Präsentation auf bestimmte Quellen.",
        showcase_tags: "Beschränken Sie die Präsentation auf Bewertungen mit bestimmten Tags.",
        signature_html: "Kopieren Sie die Signatur und fügen Sie sie in Ihr E-Mail-Programm ein.",
        signed_up: "Das Startdatum des Kunden.",
        twilio_webhook: "Legen Sie diese URL als Rückruf- URL für Ihren Nachrichtendienst fest.",
        widget_embed: "Optional. Die ID eines vorhandenen Elements, in dem das Widget erscheinen soll.",
        widget_wordpress: "Installieren Sie das Plugin und fügen Sie anschließend diesen Shortcode an der Stelle ein, an der das Widget erscheinen soll."
    },
    labels: {
        accept_all: "Alle akzeptieren",
        access_code: "Zugangscode",
        access_codes: "Zugangscodes",
        account: "Konto",
        account_sid: "Konto- SID",
        action: "Aktion",
        actions: "Aktionen",
        activate: "Aktivieren",
        active: "Aktiv",
        add: "Hinzufügen",
        add_agency_project: "Agenturprojekt hinzufügen",
        add_confirmation_message: "Fügen Sie eine Bestätigungsnachricht hinzu.",
        add_css_rules: "Fügen Sie Ihre eigenen CSS-Regeln hinzu.",
        add_custom_field: "Benutzerdefiniertes Feld hinzufügen",
        add_customer: "Einen Kunden hinzufügen",
        add_customers_with: "Kunden mit {model} hinzufügen",
        add_external_link: "Externen Link hinzufügen",
        add_external_links: "Externe Links hinzufügen",
        add_introduction: "Fügen Sie eine Einleitung hinzu.",
        add_js_tags: "Fügen Sie Ihre eigenen JavaScript Tags hinzu.",
        add_legal_information: "Fügen Sie rechtliche Informationen hinzu.",
        add_location: "Standort hinzufügen",
        add_project: "Projekt hinzufügen",
        add_review: "Bewertung hinzufügen",
        add_source: "Quelle hinzufügen",
        add_tag: "Tag hinzufügen",
        added: "Hinzugefügt",
        address: "Adresse",
        advanced_review_pages: "Erweiterte Bewertungsseiten",
        affiliates: "Partnerunternehmen",
        age_of_reviews: "Alter der Bewertungen",
        agencies: "Agenturen",
        agency: "Agentur",
        agency_name: "Name der Agentur",
        agency_project: "Agenturprojekt",
        agency_projects: "Agentur Projekte",
        ai: "KI",
        ai_answers: "KI-Antworten",
        ai_assistant: "KI-Assistent",
        ai_auto_tagging: "KI-Tagging",
        ai_highlights_instructions: "Beispiel: Bevorzuge Phrasen über den Service oder unsere Marke.",
        ai_reply_instructions: "Beispiel: Halte Antworten kurz. Lade bei negativen Bewertungen zum Kontakt ein.",
        ai_review_instructions: "Beispiel: Erwähne das Personal und den Besuch. Erwähne keine Preise.",
        ai_review_suggestions: "KI-Bewertungsvorschläge",
        ai_reviews_and_replies: "KI-Bewertungsvorschläge und Antworten",
        ai_tagging_instructions: "Beispiel: Auf Bewertungen anwenden, in denen Wartezeiten, langsamer Service oder Verzögerungen erwähnt werden.",
        ai_tags: "KI-Tags",
        ai_tools: "KI-Tools",
        all: "Alle",
        allowed_domains: "Erlaubte Domänen",
        amount: "Menge",
        analytics: "Analyse",
        and: "Und",
        anonymous_reviews: "Anonyme Bewertungen",
        answer: "Antwort",
        any: "Beliebig",
        api: "API",
        api_key: "API -Schlüssel",
        appearance: "Aussehen",
        apply: "Anwenden",
        approved: "Genehmigt",
        archive: "Archiv",
        archive_customer: "Kunde archivieren",
        archived: "Archiviert",
        at_least: "mindestens",
        at_least_days: "Mindestens {num} Tage",
        at_least_hours: "Mindestens {num} Stunden",
        at_least_months: "Mindestens {num} Monate",
        at_most: "maximal",
        at_most_days: "An höchstens {num} Tagen",
        at_most_hours: "Höchstens {num} Stunden",
        at_most_months: "Höchstens {num} Monate",
        auth_token: "Authentifizierungstoken",
        authorize: "Autorisieren",
        auto_detect: "Auto",
        auto_tags: "KI-Tags",
        automate: "Automatisieren",
        automate_highlights: "Highlights automatisieren",
        automate_replies: "Antworten automatisieren",
        automatic_review_collection: "Automatische Bewertung",
        automatically_apply_tags: "Tag automatisch auf bestehende Bewertungen anwenden",
        automating: "Automatisierung",
        avatar: "Avatar",
        avatars: "Avatare",
        average_charge: "Durchschnittliche Zahlung",
        average_review: "Durchschnittliche Bewertung",
        background_color: "Hintergrundfarbe",
        background_image: "Hintergrundbild",
        back: "Zurück",
        bcc: "BCC",
        bcc_email_address: "BCC E-Mail-Adresse",
        best_to_worst: "Vom Besten zum Schlechtesten",
        billing: "Abrechnung",
        blog: "The Reviews Guy",
        body: "Text",
        body_font_size: "Schriftgröße im Text",
        bold: "Fett",
        book_a_demo: "Demo buchen",
        bottom: "Unten",
        bottom_left: "Unten links",
        bottom_right: "Unten rechts",
        build_on: "Baue auf {model} auf.",
        business: "Business",
        business_description: "Geschäftsbeschreibung",
        business_email: "Support-E-Mail-Adresse",
        business_name: "Firmenname",
        business_phone: "Support-Telefonnummer",
        business_website: "Business Website",
        button: "Button",
        button_label: "Beschriftung für Button",
        button_link: "Link für Button",
        button_position: "Position der Button",
        button_size: "Größe des Button",
        buy_me_a_coffee: "Kauf mir einen Kaffee",
        by: "von",
        by_signing_up: "Mit der Erstellung eines Kontos stimmen Sie unseren Bedingungen zu",
        call_to_action: "Aufruf zum Handeln",
        cancel: "Abbrechen",
        cancel_1_message: "Nachricht abbrechen",
        cancel_message: "Nachricht abbrechen",
        cancel_messages: "{count}-Nachrichten abbrechen",
        cancel_subscription: "Abonnement kündigen",
        cancel_unsent_messages: "Nicht gesendete Nachrichten abbrechen",
        canceled: "Gekündigt",
        center: "Center",
        change: "Ändern",
        change_key: "Ändern Sie Ihren API Schlüssel",
        change_plan: "Plan ändern",
        changelog: "Änderungsprotokoll",
        channel: "Kanal",
        channels: "Kanäle",
        characters: "Zeichen",
        charges_avg: "Die durchschnittliche Zahlung muss mindestens betragen",
        charges_count: "Die Anzahl der Zahlungen muss mindestens betragen",
        charges_sum: "Die Gesamtzahlungen müssen mindestens betragen",
        chat_with_us: "Mit uns chatten",
        chatgpt: "ChatGPT",
        checkbox: "Kontrollkästchen",
        claude: "Claude",
        clear: "Leeren",
        clear_selection: "Auswahl löschen",
        clear_highlights_from_reviews: "Hervorhebungen aus allen Bewertungen entfernen",
        clicked: "Angeklickt",
        client: "Client",
        client_id: "Client ID",
        clients: "Clients",
        close: "Schließen",
        cloudflare_warning: "Wenn Sie Cloudflare verwenden, muss Ihr Proxy deaktiviert sein.",
        cname: "CNAME",
        cname_setup_incomplete: "Einrichtung unvollständig – wird in Version {date} entfernt",
        cname_ssl_pending: "SSL-Zertifikat wird erwartet",
        cname_status_for: "CNAME -Status für",
        code_editor: "Code-Editor",
        collapse: "Einklappen",
        collect_reviews_anywhere: "Sammeln Sie überall Bewertungen",
        color: "Farbe",
        colors: "Farben",
        commission_rate: "Provisionssatz",
        commission_status_approved: "Genehmigt",
        commission_status_paid: "Bezahlt",
        commission_status_pending: "Ausstehend",
        commission_status_reversed: "Umgedreht",
        community: "Gemeinschaft",
        company: "Unternehmen",
        complained: "Beschwert",
        confirm_new_password: "Neues Passwort bestätigen",
        confirmation_message: "Bestätigungsnachricht",
        configure: "Konfigurieren",
        connect: "Verbinden",
        connect_bank: "Bankkonto verbinden",
        connect_google: "Google verbinden",
        connect_google_business_profile: "Connect Google Business Profile",
        connected: "Verbunden",
        consent_preferences: "Einwilligungspräferenzen",
        contact_customer: "Kontakt zum Kunden",
        contact_form: "Kontaktformular",
        contact_support: "Bitte wenden Sie sich an den Support.",
        contact_us: "Kontaktieren Sie uns",
        container_element: "Containerelement",
        context: "Kontext",
        continue: "Weitermachen",
        continue_with_google: "Weiter mit Google",
        cookie_category_analytics: "Analysen",
        cookie_category_essential: "Essentiell",
        cookie_category_functional: "Funktionell",
        cookie_category_marketing: "Marketing",
        cookie_consent_banner: "Cookie-Einwilligungsbanner",
        cookie_consent_scope_all: "Allen zeigen",
        cookie_consent_scope_eea: "Nur für Besucher aus dem EWR und Großbritannien anzeigen",
        cookie_consent_scope_none: "Nicht anzeigen",
        cookie_policy: "Cookie-Richtlinie",
        cookie_preference: "Cookie Einstellungen",
        copied: "Kopiert",
        copied_message: "Kopierte Nachricht",
        copy: "Kopieren",
        copy_embed_code: "Einbettungscode kopieren",
        copy_signature: "Signatur kopieren",
        copy_source_code: "Quellcode kopieren",
        copy_to_all_ratings: "Auf alle Bewertungen kopieren",
        copy_uuid: "Kopiere UUID",
        create: "Erstellen",
        create_account: "Benutzerkonto erstellen",
        create_agency: "Eine Agentur gründen",
        create_cname: "Erstellen Sie einen CNAME Eintrag und verweisen Sie ihn auf",
        create_external_link: "Externen Link erstellen",
        create_field: "Feld erstellen",
        create_link: "Link erstellen",
        create_location: "Standort erstellen",
        create_project: "Projekt erstellen",
        create_qr_code: "QR-Code erstellen",
        create_review: "Eine Bewertung erstellen",
        create_review_page: "Erstellen Sie eine Bewertungsseite",
        create_signature: "Signatur erstellen",
        create_source: "Quelle erstellen",
        create_space: "Einen Arbeitsbereich schaffen",
        create_tag: "Tag erstellen",
        create_tag_rule: "Tag Regel erstellen",
        create_webhook: "Erstellen Sie einen Webhook",
        create_widget: "Widget erstellen",
        created_with_ai_based_on_recent_reviews: "Mit KI erstellt, basierend auf aktuellen Bewertungen",
        crms: "CRMs",
        csv: "CSV",
        currency: "Währung",
        current_plan: "Aktueller Plan",
        current_year: "Aktuelles Jahr",
        custom_field: "Benutzerdefiniertes Feld",
        custom_instructions: "Benutzerdefinierte Anweisungen",
        custom_url: "Benutzerdefinierte URL",
        customer: "Kunde",
        customer_name_convention: "Kundennamenskonvention",
        customer_reviews: "Kundenbewertungen",
        customers: "Kunden",
        customize: "Anpassen",
        customize_review_page: "Bewertungsseite anpassen",
        daily: "Täglich",
        daily_email_requests: "Tägliche E-Mail-Anfragen",
        daily_limit: "Tageslimit",
        daily_requests: "Tägliche Anfragen",
        daily_sms_requests: "Tägliche SMS Anfragen",
        dark: "Dunkel",
        dashboard: "Übersichtsseite",
        date: "Datum",
        date_added: "Datum hinzugefügt",
        date_canceled: "Kündigungsdatum",
        date_clicked: "Klickdatum",
        date_complained: "Datum der Beschwerde",
        date_delivered: "Lieferdatum",
        date_failed: "Datum fehlgeschlagen",
        date_messaged: "Datum der Nachricht",
        date_opened: "Eröffnungsdatum",
        date_replied: "Antwortdatum",
        date_requested: "Angefordertes Datum",
        date_reviewed: "Bewertet",
        date_scheduled: "Geplantes Datum",
        date_sent: "Versanddatum",
        date_signed_up: "Anmeldedatum",
        date_updated: "Aktualisierungsdatum",
        dates: "Termine",
        day: "Tag",
        days: "Tage",
        days_after_last_request: "Tage nach der letzten Anfrage",
        days_later: "Tage später",
        deactivate: "Deaktivieren",
        default: "Standard",
        default_language: "Standardsprache",
        default_review_page: "Standard-Bewertungsseite",
        default_review_visibility: "Standard-Sichtbarkeit der Bewertung",
        default_tone: "Standardton",
        delay: "Verzögerung",
        delete: "Löschen",
        delete_1_customer: "1 Kunden löschen",
        delete_1_review: "1 Bewertung löschen",
        delete_1_review_page: "Bewertungsseite löschen",
        delete_1_widget: "1 Widget löschen",
        delete_agency: "Agentur löschen",
        delete_custom_field: "Benutzerdefiniertes Feld löschen",
        delete_customer: "Kunde löschen",
        delete_customers: "Kunden löschen",
        delete_external_link: "Externen Link löschen",
        delete_field: "Feld löschen",
        delete_link: "Link löschen",
        delete_location: "Speicherort löschen",
        delete_message: "Nachricht löschen",
        delete_n_customers: "{count}-Kunden löschen",
        delete_n_review_pages: "{count}- Bewertungsseiten löschen",
        delete_n_reviews: "{count}- Bewertungen löschen",
        delete_n_widgets: "{count}-Widgets löschen",
        delete_project: "Projekt löschen",
        delete_qr_code: "QR-Code löschen",
        delete_reply: "Antwort löschen",
        delete_review: "Bewertung löschen",
        delete_review_page: "Bewertungsseite löschen",
        delete_review_pages: "Bewertungsseiten löschen",
        delete_reviews: "Bewertungen löschen",
        delete_signature: "Signatur löschen",
        delete_source: "Quelle löschen",
        delete_space: "Arbeitsbereich löschen",
        delete_tag: "Tag löschen",
        delete_tag_rule: "Tag-Regel löschen",
        delete_template: "Vorlage löschen",
        delete_user: "Benutzer löschen",
        delete_webhook: "Webhook löschen",
        delete_widget: "Widget löschen",
        delete_widgets: "Widgets löschen",
        deleted: "Gelöscht",
        delivered: "Geliefert",
        description: "Beschreibung",
        deselect_all: "Auswahl aufheben",
        disable: "Deaktivieren",
        disable_automatic_review_collection: "Automatische Bewertung deaktivieren",
        disable_field: "Feld deaktivieren",
        disable_when_links_are_visible: "Deaktivieren, wenn Links sichtbar sind",
        disabled: "Deaktiviert",
        disconnect: "Trennen",
        disconnect_integration: "Trennung der Integration",
        discord_community: "Discord -Community",
        display_name: "Anzeigename",
        dmarc: "DMARC",
        dmarc_status_for: "DMARC -Status für",
        do_not_hide_from_public: "Nicht vor der Öffentlichkeit verbergen",
        do_not_send: "Nicht senden",
        docs: "Dokumente",
        documentation: "Dokumentation",
        domain: "Domain",
        domain_name: "Domänenname",
        dont_have_an_account: "Sie haben noch kein Konto?",
        dont_send_thanks: "Senden Sie keinen Dank",
        done: "Fertig",
        download: "Herunterladen",
        download_plugin: "Plugin herunterladen",
        download_records: "Datensätze herunterladen",
        download_template: "Vorlage herunterladen",
        dpa: "DPA",
        dsar: "DSAR",
        dropdown: "Dropdown",
        duplicate: "Duplikat",
        duplicate_project: "Duplikatprojekt",
        duplicate_review_page: "Doppelte Bewertungsseite",
        duplicate_reviews: "Doppelte Bewertungen",
        duplicate_widget: "Widget duplizieren",
        edit: "Bearbeiten",
        edit_1_customer: "1 Kunden bearbeiten",
        edit_1_review: "1 Bewertung bearbeiten",
        edit_client: "Client bearbeiten",
        edit_custom_field: "Benutzerdefiniertes Feld bearbeiten",
        edit_customer: "Kunde bearbeiten",
        edit_customers: "Kunden bearbeiten",
        edit_field: "Feld bearbeiten",
        edit_link: "Link bearbeiten",
        edit_location: "Standort bearbeiten",
        edit_member: "Mitglied bearbeiten",
        edit_n_customers: "Bearbeiten Sie {count} Kunden",
        edit_n_reviews: "{count} Bewertungen bearbeiten",
        edit_notes: "Bearbeitungshinweise",
        edit_qr_code: "QR-Code bearbeiten",
        edit_reviews: "Bewertungen bearbeiten",
        edit_signature: "Signatur bearbeiten",
        edit_source: "Quelle bearbeiten",
        edit_strategy: "Strategie bearbeiten",
        edit_tag: "Tag bearbeiten",
        edit_tag_rule: "Tag-Regel bearbeiten",
        edit_tags: "Tags bearbeiten",
        edit_team_member: "Teammitglied bearbeiten",
        edit_visibility: "Sichtbarkeit bearbeiten",
        edit_webhook: "Webhook bearbeiten",
        editable_ratings: "Bearbeitbare Sternebewertung",
        earned: "Verdient",
        eligible: "Berechtigt",
        email: "E-Mail",
        email_address: "E-Mail-Adresse",
        email_validation_invalid: "E-Mail-Validierung fehlgeschlagen",
        email_validation_passed: "E-Mail-Validierung bestanden",
        email_validation_unknown: "E-Mail konnte nicht verifiziert werden",
        emails: "E-Mails",
        embed_code: "Einbettungscode",
        enable: "Aktivieren",
        enable_automatic_review_collection: "Automatische Bewertung aktivieren",
        enable_for_all_reviews: "Für alle Bewertungen aktivieren",
        enable_for_positive_reviews: "Für positive Bewertungen aktivieren",
        enable_on_review_pages: "Auf Bewertungsseiten aktivieren",
        enabled: "Aktiviert",
        end: "Ende",
        ends: "Endet",
        exclude: "Ausschließen",
        exclude_email: "E-Mail ausschließen",
        exclude_sms: "SMS ausschließen",
        excluded_channels: "Ausgeschlossene Kanäle",
        expand: "Expandieren",
        expired: "Abgelaufen",
        export: "Export",
        export_1_customer: "Export 1 Kunde",
        export_1_review: "Export 1 Bewertung",
        export_all: "Alles exportieren",
        export_all_customers: "Alle Kunden exportieren",
        export_all_reviews: "Alle Bewertungen exportieren",
        export_customers: "Kunden exportieren",
        export_n_customers: "Export {count} Kunden",
        export_n_reviews: "Export {count} Bewertungen",
        export_reviews: "Bewertungen exportieren",
        external_link: "Externer Link",
        external_links: "Externe Links",
        extra_locations: "Zusätzliche Standorte",
        faces: "Gesichter",
        failed: "Fehlgeschlagen",
        fallback_url: "Fallback-URL",
        feedback: "Rückmeldung",
        feedback_form: "Feedback-Formular",
        field: "Feld",
        fields: "Felder",
        filter: "Filter",
        first: "Erste",
        first_charged: "Erste Zahlung",
        first_name: "Vorname",
        first_name_last_initial: "Vorname, Anfangsbuchstabe des Nachnamens",
        five_star_share: "5-Sterne-%",
        flag_as_duplicate: "Als Duplikat kennzeichnen",
        font: "Schriftart",
        font_family: "Schriftfamilie",
        font_size: "Schriftgröße",
        footer: "Fußzeile",
        for: "Für",
        forgot_password: "Passwort vergessen",
        form: "Formular",
        free: "Frei",
        free_requests_included: "Kostenlose Anfragen inklusive",
        from: "aus",
        full_name: "Vollständiger Name",
        generate: "Erzeugen",
        generate_meta: "Generieren Sie Meta",
        generate_qr_code: "QR-Code generieren",
        generate_reply: "Antwort generieren",
        generate_review: "Bewertung generieren",
        generating: "Wird generiert",
        get_started: "Erste Schritte",
        get_started_checklist: "Checkliste für den Einstieg",
        get_the_lifetime_deal: "Holen Sie sich das Lifetime-Angebot",
        getting_started: "Erste Schritte",
        google_fonts: "Google Fonts",
        grouped_by_request: "Nach Anfrage gruppiert",
        has_links: "Links",
        has_notes: "Hat Notizen",
        has_redirects: "Hat Weiterleitungen",
        have_an_account: "Haben Sie bereits einen Account?",
        header: "Kopfbereich",
        hidden: "Versteckt",
        hidden_from_search_engines: "Vor Suchmaschinen verborgen",
        hidden_reviews: "Versteckte Bewertungen",
        hide: "Verstecken",
        hide_all_reviews: "Alle Bewertungen ausblenden",
        hide_avatar: "Avatar verbergen",
        hide_date: "Datum ausblenden",
        hide_drop_shadow: "Schlagschatten ausblenden",
        hide_field_label: "Feldbezeichnung ausblenden",
        hide_from_public: "Vor der Öffentlichkeit verbergen",
        hide_name: "Namen verbergen",
        hide_pagination: "Seitennummerierung ausblenden",
        highlight_color: "Hervorhebungsfarbe",
        hipaa: "HIPAA",
        host: "Host",
        hours: "Std",
        icon: "Symbol",
        icon_size: "Symbolgröße",
        icons: "Symbole",
        id: "ID",
        image: "Bild",
        import: "Import",
        import_address1: "Adresszeile des Kunden 1.",
        import_address2: "Die Adresszeile des Kunden 2.",
        import_city: "Die Stadt oder der Ort des Kunden.",
        import_company: "Der Firmenname des Kunden.",
        import_created_at: "Das Datum der Bewertung.",
        import_customers: "Kunden importieren",
        import_email: "Die E-Mail-Adresse des Kunden.",
        import_first_name: "Der Vorname des Kunden.",
        import_from_hubspot: "Import aus HubSpot",
        import_from_make_com: "Import von Make.com",
        import_from_pabbly: "Import von Pabbly",
        import_from_stripe: "Import von Stripe",
        import_from_zapier: "Import von Zapier",
        import_last_name: "Der Nachname des Kunden.",
        import_list: "Komma-getrennte Liste von",
        import_notes: "Hinweise nur für den internen Gebrauch.",
        import_phone: "Die Telefonnummer des Kunden.",
        import_postal_code: "Die Postleitzahl des Kunden.",
        import_recent_reviews: "Aktuelle Bewertungen importieren",
        import_review: "Der Bewertungstext.",
        import_reviews: "Bewertungen importieren",
        import_score: "Die Bewertung von 1 - 5.",
        import_signed_up_at: "Das Startdatum des Kunden.",
        import_slug: "Der slug oder die UUID eines",
        import_state: "Das Bundesland oder die Region des Kunden.",
        import_yourself: "Sich selbst importieren",
        incentive: "Anreiz",
        include: "Enthalten",
        include_sample_reviews: "Fügen Sie Bewertungen hinzu.",
        incoming_webhook_url: "Eingehende Webhook- URL",
        inherit: "Erben",
        initializing: "Initialisierung",
        initials: "Initialen",
        install_in: "Installieren in",
        insert_variable: "Variable einfügen",
        instructions: "Anweisungen",
        integration: "Integration",
        integrations: "Integrationen",
        interval: "Intervall",
        introduction: "Einführung",
        invite: "Einladen",
        invite_client: "Client einladen",
        invite_failed: "Einladung fehlgeschlagen",
        invite_member: "Mitglied einladen",
        invite_sent_to: "Einladung gesendet an",
        invite_team_member: "Teammitglied einladen",
        invited: "Eingeladen",
        issuer_url: "Issuer-URL",
        italic: "Kursiv",
        joined: "Beigetreten",
        jpg: "JPG",
        key: "Schlüssel",
        keywords: "Schlüsselwörter",
        keywords_in_replies: "Schlüsselwörter in Antworten",
        keywords_in_reviews: "Schlüsselwörter in Bewertungen",
        kiosk_page: "Kiosk-Seite",
        label: "Etikett",
        label_font_size: "Schriftgröße für Etiketten",
        labels: "Labels",
        language: "Sprache",
        languages: "Sprachen",
        large: "Groß",
        last_12_months: "Letzte 12 Monate",
        last_2_years: "Letzte 2 Jahre",
        last_3_months: "Letzte 3 Monate",
        last_4_weeks: "Letzte 4 Wochen",
        last_6_months: "Letzte 6 Monate",
        last_charged: "Letzte Belastung",
        last_name: "Nachname",
        layout: "Layout",
        leave: "Verlassen",
        leave_project: "Projekt verlassen",
        leave_space: "Arbeitsbereich verlassen",
        left: "Links",
        let_clients_sign_in_with_sso: "Kunden mit SSO anmelden lassen",
        less: "weniger",
        lifecycle_stage: "Lebenszyklusphase",
        lifetime_deal: "Lebenslanges Angebot",
        lifetime_deal_terms: "Bedingungen für das lebenslange Angebot",
        light: "Licht",
        limit: "Limit",
        limits: "Grenzen",
        link: "Link",
        link_color: "Linkfarbe",
        link_reveal_position: "Link -Anzeigeposition",
        link_revealer_button: "Link Button",
        link_revealer_label: "Bezeichnung für Link Revealer",
        link_revealer_rating: "Link Revealer Bewertung",
        links: "Links",
        links_per_review_page: "Links pro Bewertungsseite",
        list: "Liste",
        list_unsubscribe_headers: "List-Unsubscribe Header",
        load_more: "Mehr laden",
        loading: "Laden",
        location: "Standort",
        location_address: "Standortadresse",
        location_name: "Standortname",
        location_picker: "Standortauswahl",
        locations: "Standorte",
        locations_limit: "Standortlimit",
        log_in: "Einloggen",
        log_out: "Ausloggen",
        logo: "Logo",
        logo_height: "Logohöhe",
        long: "Lang",
        lowest_rating: "Niedrigste Bewertung",
        ltd: "LTD",
        make_default: "Als Standard festlegen",
        manage: "Verwalten",
        manage_limits: "Limits verwalten",
        manage_overrides: "Außerkraftsetzungen verwalten",
        manage_payout_account: "Auszahlungskonto verwalten",
        manage_subscription: "Abonnement verwalten",
        manual_entry: "Manuelle Eingabe",
        max: "Max",
        max_size: "Maximale Größe",
        maximum_characters: "Maximale Zeichen",
        maximum_customers: "Maximale Kundenzahl",
        maximum_locations: "Maximale Anzahl Standorte",
        maximum_members: "Maximale Mitgliederzahl",
        maximum_review_length: "Maximale Bewertung",
        maximum_tags: "Maximale Tags",
        maximum_widgets: "Maximale Widgets",
        mcp: "MCP Server",
        mcp_server: "MCP Server",
        mcp_server_url: "MCP Server URL",
        medium: "Medium",
        member: "Mitglied",
        members: "Mitglieder",
        menu: "Speisekarte",
        message: "Nachricht",
        message_link_expiration: "Ablaufdatum des Link",
        messaged: "Angeschrieben",
        messages: "Nachrichten",
        messages_clicked: "Angeklickte Nachrichten",
        messages_sent: "Gesendete Nachrichten",
        messaging_service_sid: "Messagingdienst- SID",
        min: "Mindest",
        min_size: "Mindestgröße",
        minimal_delay: "Minimale Verzögerung",
        minimum_characters: "Mindestanzahl an Zeichen",
        minutes: "Minuten",
        month: "Monat",
        month_to_date: "Monat bis heute",
        monthly: "Monatlich",
        monthly_email_requests: "Monatliche E-Mail-Anfragen",
        monthly_limit: "Monatliches Limit",
        monthly_pricing_only: "Nur monatliche Preisgestaltung",
        monthly_request_limit: "Monatliches Anfragelimit",
        monthly_requests: "Monatliche Anfragen",
        monthly_sms_requests: "Monatliche SMS Anfragen",
        months: "Monate",
        months_free: "{count} Monate kostenlos",
        more: "mehr",
        more_clients: "mehr Clients",
        more_customers: "mehr Kunden",
        more_options: "Weitere Optionen",
        more_patients: "mehr Patienten",
        more_reviews: "weitere Bewertungen",
        more_reviews_needed: "Zur Zusammenfassung sind weitere Bewertungen erforderlich",
        more_users: "mehr Nutzer",
        more_visitors: "mehr Besucher",
        most_negative: "Am negativsten",
        most_positive: "Am positivsten",
        move: "Bewegen",
        moved: "Verschoben",
        name: "Name",
        native_reviews: "Native Bewertungen",
        negative: "Negativ",
        negative_term: "Negativer Begriff",
        new: "Neu",
        new_password: "Neues Passwort",
        newest: "Neueste",
        neutral: "Neutral",
        no: "Nein",
        no_available_options: "Keine verfügbaren Optionen",
        no_credit_card_required: "Keine Kreditkarte erforderlich",
        no_data_available: "Keine Daten verfügbar",
        no_reminders: "Senden Sie keine Erinnerungen",
        no_retries: "Keine Wiederholungsversuche",
        no_review: "Keine Bewertung",
        none: "Keiner",
        not_connected: "Nicht verbunden",
        not_reviewed: "Nicht Bewertet",
        notes: "Anmerkungen",
        notifications: "Benachrichtigungen",
        now: "Jetzt",
        n_1_ai_tag: "1 KI-Tag",
        n_1_review_page: "1 Bewertungsseite",
        n_ai_tags: "{count} KI-Tags",
        n_review_pages: "{count} Bewertungsseiten",
        number_of_charges: "Anzahl der Zahlungen",
        number_of_reminders: "Anzahl der Erinnerungen",
        number_of_retries: "Anzahl der Wiederholungsversuche",
        number_of_review_suggestions: "Anzahl der Bewertungsvorschläge",
        of: "von",
        off: "Aus",
        on: "An",
        on_for_positive_reviews: "An für positive Bewertungen",
        on_channel: "auf Kanal {channel}.",
        opened: "Geöffnet",
        options: "Optionen",
        or_log_in_with_email: "oder melden Sie sich mit Ihrer E-Mail-Adresse an",
        or_sign_up_with_email: "oder verwenden Sie Ihre E-Mail-Adresse",
        other_website: "Andere Website",
        our_reviews: "Unsere Bewertungen",
        output: "Ausgabe",
        page_footer: "Seitenfußzeile",
        paid: "Bezahlt",
        paragraph: "Absatz",
        password: "Passwort",
        past_month: "Letzter Monat",
        past_months: "Letzte {inc} Monate",
        past_week: "Letzte Woche",
        past_year: "Letztes Jahr",
        past_years: "Vergangene {inc} Jahre",
        paused: "Angehalten",
        payment_method: "Zahlungsmethode",
        payout_status_completed: "Vollendet",
        payout_status_pending: "Ausstehend",
        pending: "Ausstehend",
        pending_deployment: "Ausstehende Bereitstellung",
        pending_validation: "Ausstehende Validierung",
        per_day: "pro Tag",
        per_month: "pro Monat",
        period: "Zeitraum",
        permissions: "Berechtigungen",
        phone: "Telefon",
        phone_number: "Telefonnummer",
        pixels: "Pixel",
        placeholder: "Platzhalter",
        placement: "Platzierung",
        plan: "Tarif",
        plan_bullet1: "Entfernen Sie unser Branding aus E-Mails, Seiten und Widgets",
        plan_bullet2: "Verwenden Sie Ihre Domain für kundenseitige Seiten und den E-Mail-Versand",
        plan_bullet3: "Machen Sie das Produkt zu Ihrem mit White Labeling für Agenturen",
        please_rate_our_service: "Bitte bewerten Sie unseren Service.",
        png: "PNG",
        policies: "Richtlinien",
        positive: "Positiv",
        popular: "Beliebt",
        port: "Port",
        position: "Position",
        positive_only: "Nur positive Bewertungen",
        positive_term: "Positiver Begriff",
        powered_by: "Angetrieben von",
        preview: "Vorschau",
        preview_kiosk_page: "Kiosk-Seite ansehen",
        preview_review_page: "Bewertungsseite ansehen",
        price: "Preis",
        pricing: "Preise",
        primary_color: "Grundfarbe",
        priority: "Priorität",
        privacy_policy: "Datenschutzrichtlinie",
        proceed_to_dashboard: "Weiter zur Übersichtsseite",
        product: "Produkt",
        profile: "Profil",
        project: "Projekt",
        project_name: "Projektname",
        setup_ask_delay: "Wie lange sollte man warten, bevor man um eine Bewertung bittet?",
        setup_reminders: "Wie viele Erinnerungen sollen gesendet werden?",
        project_paused: "Dieses Projekt ist pausiert.",
        project_suspended: "Dieses Projekt ist ausgesetzt.",
        project_website: "Projektwebsite",
        projects: "Projekte",
        projects_limit: "Projektlimit",
        publish: "Veröffentlichen",
        publish_changes: "Veröffentlichen Sie die Änderungen auf allen anderen Bewertungsseiten",
        published: "Veröffentlicht",
        purchase: "Kaufen",
        qr_code: "QR-Code",
        qr_code_name_placeholder: "Tisch 1, Rezeption",
        qr_codes: "QR-Codes",
        quarter_to_date: "Quartal bis heute",
        quantity: "Menge",
        query: "Abfrage",
        quick_import: "Schnellimport",
        rating: "Sternebewertung",
        rating_order: "Bewertungsreihenfolge",
        rating_out_of: "Bewertung von",
        rating_save_all: "Bewertung vor jeder Bewertung speichern",
        rating_save_customer: "Bewertung vor einer Kundenbewertung speichern",
        rating_save_never: "Bewertung nie vor der Bewertung speichern",
        rating_selection: "Bewertungsauswahl",
        rating_selector: "Bewertungsauswahl",
        ratings: "Sternebewertung",
        read: "Lesen",
        reapply_highlights_eligible: "Regenerieren Sie mithilfe von KI Highlights für alle positiven Bewertungen",
        reconnect: "Erneut verbinden",
        redeem: "Einlösen",
        redirect_uri: "Umleitungs-URI",
        redirects: "Weiterleitungen",
        refer_and_earn: "Empfehlen & Verdienen",
        referral_billing_status_active: "Abonniert",
        referral_billing_status_canceled: "Abgesagt",
        referral_billing_status_trial: "Testphase",
        referral_billing_status_trial_expired: "Testphase abgelaufen",
        referral_billing_status_trial_expiring: "Testphase läuft ab",
        referral_program: "Bedingungen des Empfehlungsprogramms",
        referral_program_terms: "Bedingungen des Empfehlungsprogramms",
        referrals: "Empfehlungen",
        refresh: "Aktualisieren",
        regenerate: "Regenerieren",
        reject_all: "Alle ablehnen",
        related_reviews: "Ähnliche Bewertungen",
        related_similarity: "Ähnlichkeit",
        remaining: "Übrig",
        reminder: "Erinnerung",
        reminders: "Erinnerungen",
        remove: "Entfernen",
        remove_client: "Client entfernen",
        remove_cname: "CNAME entfernen",
        remove_domain: "Domain entfernen",
        remove_from_project: "Aus Projekt entfernen",
        remove_member: "Mitglied entfernen",
        remove_smtp_configuration: "SMTP Konfiguration entfernen",
        remove_team_member: "Teammitglied entfernen",
        rename: "Umbenennen",
        rename_template: "Vorlage umbenennen",
        renews: "Erneuert",
        replied: "Antwortete",
        reply: "Antwort",
        reply_coverage: "Antwortquote",
        replies: "Öffentliche Antworten",
        replies_disabled: "Öffentliche Antworten deaktiviert",
        reply_to: "Antwortadresse",
        replying_on: "Antworten auf",
        request: "Anfrage",
        request_1_review: "1 Bewertung anfordern",
        request_date: "Anfragedatum",
        request_n_reviews: "{count} Bewertungen anfordern",
        request_review: "Bewertung anfordern",
        request_reviews: "Bewertungen anfordern",
        requested: "Angefordert",
        requested_review: "Bewertung angefordert",
        requests: "Anfragen",
        requests_left_this_month: "Anfragen diesen Monat",
        requests_remaining: "Verbleibende Anfragen",
        require_field: "Feld erforderlich",
        require_sso: "SSO erforderlich",
        required: "Erforderlich",
        reschedule_message: "Nachricht neu planen",
        resend_invite: "Einladung erneut senden",
        reset_password: "Passwort zurücksetzen",
        restore: "Wiederherstellen",
        restore_to_defaults: "Auf Standardeinstellungen zurücksetzen",
        restore_widget: "Widget wiederherstellen",
        resubscribe: "erneut abonnieren",
        resubscribe_customer: "Kunde erneut abonnieren",
        resync: "Neu synchronisieren",
        resync_account: "Konto erneut synchronisieren",
        resync_now: "Jetzt neu synchronisieren",
        retries: "Wiederholungsversuche",
        reveal_above_form: "Formular oben anzeigen",
        reveal_after_submission: "Nach der Übermittlung anzeigen",
        reveal_below_form: "Formular unten anzeigen",
        review: "Bewertung",
        review_length: "Länge der Bewertung",
        review_link: "Link zur Bewertung",
        review_missed: "Bewertung verpasst",
        review_not_requested: "Bewertung nicht angefordert",
        review_origin: "Diese Bewertung stammt aus Vorlage",
        review_page: "Bewertungsseite",
        review_pages: "Bewertungsseiten",
        review_requested: "Bewertung angefordert",
        review_spotlight: "Bewertungs-Spotlight",
        review_suggestion: "Bewertungsvorschlag",
        review_suggestions: "Bewertungsvorschläge",
        review_summary: "Bewertungszusammenfassung",
        review_text: "Bewertung",
        review_velocity: "Bewertungen pro Woche",
        review_volume: "Bewertungsvolumen",
        review_wall: "Bewertungswand",
        reviewed: "Bewertet",
        reviews: "Bewertungen",
        reviews_ask: "Anfragen",
        reviews_query_failed: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
        reviews_query_placeholder: "Bewertungen durchsuchen oder eine Frage stellen...",
        reviews_with_highlights: "Bewertungen mit Highlights",
        reviews_with_replies: "Bewertungen mit Antworten",
        reviews_without_replies: "Bewertungen ohne Antworten",
        revoke: "Widerrufen",
        revoke_client: "App widerrufen",
        roadmap: "Fahrplan",
        role: "Rolle",
        sans_serif: "Serifenlos",
        save: "Speichern",
        save_preferences: "Einstellungen Speichern",
        save_template: "Vorlage Speichern",
        save_template_as_new: "Neue Vorlage Speichern",
        saved: "Gespeichert",
        schedule: "Zeitplan",
        schedule_review_request: "Bewertungsanfrage planen",
        scheduled: "Geplant",
        score: "Punktzahl",
        search: "Suchen",
        second: "Zweite",
        secret_key: "Geheimer Schlüssel",
        sections: "Abschnitte",
        security_code: "Sicherheitscode",
        select: "Wählen",
        select_account: "Konto auswählen",
        select_all: "Alles auswählen",
        select_all_1: "1 Zeile auswählen",
        select_all_count: "Alle {count} Zeilen auswählen",
        select_an_option: "Wählen Sie eine Option",
        select_bulk_action: "Massenaktion auswählen",
        select_csv_file: "CSV Datei auswählen",
        select_date: "Datum auswählen",
        select_field: "Wählen Sie ein Feld aus",
        select_icon: "Wählen Sie ein Symbol aus",
        select_location: "Wählen Sie einen Standort aus",
        select_plan: "Wählen Sie einen Tarif",
        select_review: "Wählen Sie eine Bewertung aus",
        select_source: "Wählen Sie eine Quelle aus",
        select_tag: "Wählen Sie ein Tag aus",
        selected: "Ausgewählt",
        send: "Schicken",
        send_1_reminder: "1 Erinnerung senden",
        send_2_reminders: "2 Erinnerungen senden",
        send_3_reminders: "3 Erinnerungen senden",
        send_anytime: "Jederzeit senden",
        send_between: "Senden zwischen",
        send_message: "Nachricht senden",
        send_retries: "Sende {count} Wiederholungsversuche",
        send_retry: "Senden Sie {count} erneut",
        send_test: "Senden Sie einen Test",
        send_thanks: "Danke senden",
        sender_email_address: "E-Mail-Adresse des Absenders",
        sender_id: "Absender ID",
        sender_name: "Absendername",
        sending_domain: "Absenderdomäne",
        sentiment: "Stimmung",
        sent: "Gesendet",
        sent_replies: "Gesendete Antworten",
        serif: "Serif",
        set_up: "Einrichten",
        settings: "Einstellungen",
        share: "Teilen",
        share_link: "Link teilen",
        short: "Kurz",
        shortcode: "Shortcode",
        show: "Zeigen",
        show_1_suggestion: "1 Vorschlag anzeigen",
        show_100_results: "100 Ergebnisse anzeigen",
        show_2_suggestions: "2 Vorschläge anzeigen",
        show_25_results: "25 Ergebnisse anzeigen",
        show_3_suggestions: "3 Vorschläge anzeigen",
        show_4_suggestions: "4 Vorschläge anzeigen",
        show_5_suggestions: "5 Vorschläge anzeigen",
        show_50_results: "50 Ergebnisse anzeigen",
        show_all_reviews: "Alle Bewertungen anzeigen",
        show_arrows: "Pfeile anzeigen",
        show_avatar: "Avatar anzeigen",
        show_cookie_consent_banner: "Cookie-Einwilligungsbanner anzeigen",
        show_date: "Datum anzeigen",
        show_dots: "Punkte anzeigen",
        show_drop_shadow: "Schlagschatten anzeigen",
        show_field: "Feld bei folgenden Sternebewertung anzeigen",
        show_full: "Alle Sterne anzeigen",
        show_photo: "Nur Foto anzeigen",
        show_positive_reviews: "Nur positive Bewertungen anzeigen",
        show_to_public: "Der Öffentlichkeit zeigen",
        showcase: "Showcase",
        showcase_page: "Showcase-Seite",
        sign_up: "Melden Sie sich an",
        sign_up_for_free: "Kostenlos registrieren",
        sign_up_with_email: "Mit E-Mail registrieren",
        sign_in_with_sso: "Mit SSO anmelden",
        sign_up_with_google: "Mit Google registrieren",
        signature: "Signatur",
        signatures: "Signaturen",
        signed_up: "Angemeldet",
        since: "Seit",
        size: "Größe",
        skip: "Überspringen",
        skipped_required_fields: "Pflichtfelder übersprungen: {fields}",
        slug: "Slug",
        small: "Klein",
        sms: "SMS",
        smtp_configuration: "SMTP Konfiguration",
        sort: "Sortieren",
        source: "Quelle",
        source_code: "Quellcode",
        sources: "Quellen",
        space: "Arbeitsbereich",
        space_name: "Arbeitsbereich",
        spaces: "Arbeitsbereiche",
        split: "Teilt",
        sso: "SSO",
        standard: "Standard",
        star: "Stern",
        star_color: "Sternfarbe",
        stars: "Sterne",
        start: "Start",
        start_free_trial: "Kostenlose Testversion starten",
        start_getting_more_reviews: "Jetzt mehr Bewertungen erhalten",
        start_over: "Neu starten",
        status: "Status",
        store_code: "Filialcode",
        strategy: "Strategie",
        sub_processors: "Subprozessoren",
        subject: "Betreff",
        subscribe: "Abonnieren",
        subscription: "Abonnement",
        success_page: "Erfolgsseite",
        suggestion: "Anregung",
        suggestions: "Vorschläge",
        summary: "Zusammenfassung",
        support: "Support",
        suspend: "Aussetzen",
        suspend_project: "Projekt aussetzen",
        suspended: "Ausgesetzt",
        svg: "SVG",
        switch_to_smtp_setup: "Wechseln Sie zum SMTP Setup",
        switch_to_standard_setup: "Zum Standard-Setup wechseln",
        symbol: "Symbol",
        sync: "Synchronisieren",
        sync_account: "Konto synchronisieren",
        sync_now: "Jetzt synchronisieren",
        sync_scheduled_time: "Synchronisierung geplant {time}",
        sync_with_facebook: "Mit Facebook synchronisieren",
        sync_with_google: "Mit Google synchronisieren",
        synced_time: "Synchronisiert {time}",
        system: "System",
        system_fonts: "Systemschriftarten",
        tag: "Tag",
        tag_1_customer: "Tag 1 Kunde",
        tag_1_review: "Tag 1 Bewertung",
        tag_customers: "Kunden taggen",
        tag_existing_reviews: "Vorhandene Bewertungen Tag",
        tag_n_customers: "Tag {count} Kunden",
        tag_n_reviews: "Tag {count} Bewertungen",
        tag_reviews: "Bewertungen taggen",
        tag_rule: "Tag-Regel",
        tag_with_ai: "Tag mit KI",
        tags: "Tags",
        tags_for_customers: "Tags für Kunden",
        tags_for_reviews: "Tags für Bewertungen",
        team: "Team",
        team_member: "Teammitglied",
        team_members: "Teammitglieder",
        template: "Vorlage",
        templates: "Vorlagen",
        terms_of_service: "Servicebedingungen",
        test_template: "Testvorlage",
        tests: "Tests",
        text: "Text",
        text_alignment: "Textausrichtung",
        text_color: "Textfarbe",
        thank_you_messages: "Dankesnachrichten",
        thanks: "Danke",
        theme: "Thema",
        third: "Dritte",
        time_zone: "Zeitzone",
        timeframe: "Zeitraum",
        title: "Titel",
        tone: "Ton",
        top: "Spitze",
        top_left: "Oben links",
        top_right: "Oben rechts",
        total_charges: "Gesamtzahlungen",
        total_reviews: "Bewertungen gesamt",
        trend_mentions: "{count} Erwähnungen, {percent}%",
        trigger: "Auslösen",
        trigger_charged: "Anfrage nach Zahlung senden",
        trigger_created: "Anfrage nach der Anmeldung senden",
        try_free: "Kostenlos testen",
        try_it_free: "Kostenlos testen",
        type: "Typ",
        types: "Arten",
        unarchive: "Entarchivieren",
        unarchive_customer: "Kundenarchivierung aufheben",
        underline: "Unterstreichen",
        unflag_as_duplicate: "Markierung als Duplikat aufheben",
        unknown: "Unbekannt",
        unlimited: "unbegrenzt",
        unnamed: "Unbenannt",
        unpublish: "Veröffentlichung aufheben",
        unpublished: "Unveröffentlicht",
        unreplied: "Unbeantwortet",
        unsent_messages: "Nicht gesendete Nachrichten",
        unsubscribe: "Abbestellen",
        unsubscribe_1_customer: "1 Kunden abmelden",
        unsubscribe_customer: "Kunde abmelden",
        unsubscribe_customers: "Kunden abmelden",
        unsubscribe_n_customers: "{count} Kunden abmelden",
        unsubscribe_text: "Abmeldetext",
        unsubscribed: "Abgemeldet",
        unsuspend: "Entsperren",
        unsuspend_project: "Projekt wieder aufnehmen",
        unverified: "Nicht verifiziert",
        update: "Aktualisieren",
        update_password: "Passwort aktualisieren",
        update_plan: "Aktualisierungsplan",
        update_share_template: "Vorlage aktualisieren",
        updated: "Aktualisiert",
        updates: "Aktualisierungen",
        upgrade: "Aktualisierung",
        upgrade_for_more: "Upgrade für mehr",
        upgrade_to_use: "Bitte aktualisieren Sie, um diese Funktion zu nutzen",
        upload: "Hochladen",
        upload_csv: "CSV hochladen",
        upload_icon: "Lade ein Symbol hoch",
        url: "URL",
        use: "Verwenden",
        use_filters_for_aggregate: "Verwenden Sie Filter für Aggregate",
        user: "Benutzer",
        user_id: "Benutzer- ID",
        user_info: "Benutzerinformationen",
        username: "Benutzername",
        utc: "UTC",
        validate: "Bestätigen",
        validate_customer_email: "Kunden-E-Mail validieren",
        validation: "Validierung",
        validations: "Validierungen",
        value: "Wert",
        verify: "Verifizieren",
        verify_email_address: "E-Mail-Adresse bestätigen",
        view: "Ansehen",
        view_all: "Alle anzeigen",
        view_all_features: "Alle Funktionen anzeigen",
        view_available_fields: "Verfügbare Felder anzeigen",
        view_documentation: "Dokumentation ansehen",
        view_email_templates: "E-Mail-Vorlagen anzeigen",
        view_review_pages: "Bewertungsseiten anzeigen",
        view_reviews: "Bewertungen ansehen",
        vs_prior: "ggü. Vorperiode",
        view_settings: "Ansichtseinstellungen",
        view_setup_guide: "Installationsanleitung anzeigen",
        view_showcase: "Showcase ansehen",
        view_strategy: "Strategie anzeigen",
        visibility: "Sichtbarkeit",
        visible: "Sichtbar",
        visible_reviews: "Sichtbare Bewertungen",
        visible_to_search_engines: "Sichtbar für Suchmaschinen",
        wait_between_reminders: "Warten Sie zwischen den Erinnerungen",
        wait_period: "Wartezeit",
        webhook: "Webhook",
        webhooks: "Webhooks",
        website: "Webseite",
        weekly: "Wöchentlich",
        weeks: "Wochen",
        widget: "Widget",
        widgets: "Widgets",
        with_ai: "mit KI",
        wordpress: "WordPress",
        worst_to_best: "Vom Schlechtesten zum Besten",
        would_redirect_to: "Würde weiterleiten zu {url}",
        write: "Schreiben",
        written_reviews: "Schriftliche Bewertungen",
        year: "Jahr",
        year_to_date: "Jahr bis heute",
        yearly: "Jährlich",
        yes: "Ja",
        you: "Du",
        your_referral_link: "Ihr Empfehlungslink"
    },
    landing: {
        announcement: "Bewertungen in {claude} oder {chatgpt} verwalten",
        counter: "Schließen Sie sich über 5.000 lokalen Dienstleistungsunternehmen an",
        counter_agencies: "Genutzt von 500+ Agenturen für Bewertungsmanagement",
        counter_ai: "Bewertungen in {claude} oder {chatgpt} verwalten",
        ai_screen_1_badge: "MCP",
        ai_screen_1_bullets: [
            "Erhalten Sie Antworten, ohne sich in ein weiteres Dashboard einzuloggen.",
            "Nutzen Sie die Reputation in den Chat-Tools, die Ihr Team bereits öffnet.",
            "Speichern jede Woche Stunden, indem Sie fragen, anstatt zu graben."
        ],
        ai_screen_1_subtitle: "Ihre Reputationsarbeit sollte Sie dort erreichen, wo Sie ohnehin schon denken. Fragen Sie Claude oder ChatGPT , was eine Antwort benötigt, wen Sie als Nächstes ansprechen sollten oder wie die Woche verlaufen ist, und erhalten Sie Live-Antworten, ohne das Tool wechseln zu müssen.",
        ai_screen_1_title: "Frag Claude oder ChatGPT",
        ai_screen_2_badge: "KI-Antworten",
        ai_screen_2_bullets: [
            "Reagiere schneller, ohne dabei unpersönlich zu klingen.",
            "Lassen Sie Bewertungen niemals unbeantwortet, wenn Sie beschäftigt sind.",
            "Schützen Sie Ihre Markenbotschaft in jeder öffentlichen Antwort"
        ],
        ai_screen_2_subtitle: "Jede unbeantwortete Bewertung ist eine verpasste Chance, Vertrauen zu gewinnen. KI entwirft Antworten, die sich natürlich anhören, sodass Sie die Warteschlange in wenigen Minuten abarbeiten und für Ihre Kunden da sein können, ohne sich mühsam mit dem Schreiben auseinandersetzen zu müssen.",
        ai_screen_2_title: "Antworte ohne unnötigen Aufwand.",
        ai_screen_3_badge: "KI-Vorschläge",
        ai_screen_3_bullets: [
            "Mehr Kunden zum Ziel bringen",
            "Sammeln Sie spezifisches und teilbares Feedback.",
            "Verwandeln Sie positive Besuche in Bewertungen , die man gerne vorzeigt."
        ],
        ai_screen_3_subtitle: "Die meisten Leute nehmen sich vor, eine Bewertung zu schreiben, tun es aber nie. Formulieren Sie Ihre Anmerkungen klar und deutlich in Ihrem eigenen Stil, damit sie ihre Texte besser abrunden und aussagekräftiger gestaltet werden können.",
        ai_screen_3_title: "Erhalten Sie mehr 5-Sterne Bewertungen",
        ai_screen_4_badge: "KI-Tagging",
        ai_screen_4_bullets: [
            "Muster erkennen, bevor sie zu Problemen werden",
            "Finden Sie die Themen, die die Einschaltquoten tatsächlich beeinflussen.",
            "Überspringen Sie das manuelle Lesen hunderter Bewertungen ."
        ],
        ai_screen_4_subtitle: "Sie sollten nicht jede Rezension erneut lesen müssen, um zu wissen, was los ist. KI ordnet das Feedback den für Sie relevanten Themen zu, sodass Sie Probleme schneller beheben und sich verstärkt auf das konzentrieren können, was Ihre Kunden lieben.",
        ai_screen_4_title: "Erfahren Sie, was Kunden sagen",
        ai_summary_1_desc: "Entwerfen Sie Google und Facebook-Antworten, die zu Ihrem Tonfall passen, oder richten Sie automatische Antworten nach einem Zeitplan ein.",
        ai_summary_1_title: "KI-Antworten",
        ai_summary_2_desc: "Bieten Sie Ihren Kunden sofort verwendbare Bewertungsvorschläge an, wenn sie Feedback auf Ihrer Seite hinterlassen.",
        ai_summary_2_title: "KI-Überprüfungsvorschläge",
        ai_summary_3_desc: "Heben Sie die besten Formulierungen aus positiven Bewertungen in Widgets, Präsentationen und geteilten Bildern hervor.",
        ai_summary_3_title: "KI-Highlights",
        ai_summary_4_desc: "Verwenden Sie Tags aus von Ihnen definierten Regeln, um Themen wie Wartezeiten oder Servicequalität übersichtlich zu gestalten.",
        ai_summary_4_title: "KI-gesteuerte automatische Verschlagwortung",
        ai_summary_5_desc: "Erhalten Sie prägnante Zusammenfassungen aktueller Bewertungen mit Angaben zu Anzahl, Themen und Handlungsempfehlungen.",
        ai_summary_5_title: "Zusammenfassungen der Bewertung",
        ai_summary_6_desc: "Erkennen Sie aufkommendes Lob und aufkommende Kritik, ohne jede Rezension einzeln lesen zu müssen.",
        ai_summary_6_title: "Positive und negative Trends",
        ai_summary_7_desc: "Suchen Sie nach ähnlichen Bewertungen neben jedem Feedback, damit Muster und Wiederholungen leicht erkennbar sind.",
        ai_summary_7_title: "Ähnliche Bewertungen",
        ai_summary_8_desc: "Stellen Sie in einfacher Sprache Fragen zu Ihren Bewertungen und erhalten Sie Antworten mit Zitaten, die Sie öffnen können.",
        ai_summary_8_title: "Frag die KI",
        ai_summary_9_desc: "Verbinden Sie Claude, ChatGPT und andere MCP Clients, um die Reputation im Chat zu verwalten.",
        ai_summary_9_title: "MCP für Assistenten",
        ai_summary_10_desc: "Rufen Sie Live-Reputationsberichte ab, die Volumen, Bewertungen, Standorte, Antworten und Reichweite abdecken.",
        ai_summary_10_title: "Reputationsberichte",
        ai_summary_11_desc: "Leitton, Schlüsselwörter und benutzerdefinierte Anweisungen sorgen dafür, dass jede KI-Ausgabe wie Ihre Marke klingt.",
        ai_summary_11_title: "Markenbewusste KI",
        ai_summary_12_desc: "Bewerten Sie, wie stark geschriebene Bewertungen positiv oder negativ wirken, über Sterne hinaus, und sortieren Sie, was Aufmerksamkeit braucht.",
        ai_summary_12_title: "Stimmung",
        industries: {
            accountants: "Buchhalter",
            auto_repair: "Automechaniker",
            chiropractors: "Chiropraktiker",
            camps: "Camps",
            cleaning: "Reinigungskräfte",
            contractors: "Handwerker",
            dentists: "Zahnärzte",
            doctors: "Ärzte",
            electricians: "Elektriker",
            financial_advisors: "Finanzberater",
            hvac: "HLK-Techniker",
            insurance_brokers: "Versicherungsmakler",
            landscapers: "Landschaftsgärtner",
            law_firms: "Anwälte",
            locksmiths: "Schlüsseldienste",
            mortgage_brokers: "Hypothekenmakler",
            optometrists: "Optometristen",
            personal_trainers: "Personal Trainer",
            pest_control: "Schädlingsbekämpfer",
            physical_therapists: "Physiotherapeuten",
            plumbers: "Klempner",
            real_estate: "Immobilienmakler",
            restaurants: "Restaurantbesitzer",
            salons: "Friseure",
            self_storage: "Lagerbetreiber",
            spas: "Kosmetiker",
            preschools: "Kindergärten",
            tour_guides: "Reiseleiter",
            veterinarians: "Tierärzte"
        },
        industries_title: "Bewertungsmanagement für lokale Dienstleister",
        stat_1_article: "Verbraucherforschungsbericht",
        stat_1_desc: "Die Leute wollen mehr als 100 Bewertungen, bevor sie einem Online-Unternehmen vertrauen.",
        stat_1_source: "Schwarzwurzel",
        stat_1_title: "Bewertungen schaffen Vertrauen",
        stat_2_article: "Lokale Bewertung",
        stat_2_desc: "Kunden, die lokale Unternehmen vergleichen, bevorzugen diejenigen, die auf jede Bewertung antworten.",
        stat_2_source: "BrightLocal",
        stat_2_title: "Wählen Sie aus, wer antwortet.",
        stat_3_article: "Bewertungen, Reputation und Umsatz",
        stat_3_desc: "Eine kleine Verbesserung Ihrer Bewertung kann eine deutliche Steigerung Ihres Verdienstes bedeuten.",
        stat_3_source: "Harvard Business School",
        stat_3_title: "Umsatz pro Stern",
        stat_4_article: "Verbraucherabhängigkeit von KI-Suchergebnissen",
        stat_4_desc: "Wenn Menschen KI fragen, wen sie auswählen soll, helfen Ihre Bewertungen dabei, die Antwort zu formulieren.",
        stat_4_source: "Bain & Company",
        stat_4_title: "Verlassen Sie sich auf die KI-Suche.",
        subtitle: "Fordern Sie automatisch Bewertungen an. Erhalten Sie mehr 5-Sterne-Bewertungen. Erreichen Sie ein höheres Ranking als Ihre Konkurrenz.",
        agencies_screen_1_badge: "Portal",
        agencies_screen_1_bullets: [
            "Verkaufen Sie ein Markenportal mit jedem Mandat",
            "Halten Sie Ihre Kunden in Ihrem Ökosystem, nicht über einen Drittanbieter-Login.",
            "Sieht aus wie ein Softwareunternehmen, ohne selbst eines zu bauen."
        ],
        agencies_screen_1_subtitle: "Geben Sie jedem Kunden ein Portal, das wie ein Produkt aussieht, das Sie gebaut haben: Ihr Logo, Ihre Farben, Ihre Domain. Dann packen Sie Bewertungsmanagement als wiederkehrenden Service, in den sie jeden Monat einloggen. Sie empfehlen kein Tool. Sie liefern eines.",
        agencies_screen_1_title: "Ein Portal, von dem sie denken, Sie haben es gebaut",
        agencies_screen_2_badge: "Kontrolle",
        agencies_screen_2_bullets: [
            "Passen Sie die Funktionen den Starter-, Wachstums- und Premium-Paketen an.",
            "Laden Sie die richtigen Leute ein und kontrollieren Sie, was jeder Kunde sieht.",
            "Überschreibungsanfragen, Standorte und Beschränkungen pro Projekt"
        ],
        agencies_screen_2_subtitle: "Nicht jeder Kunde sollte alles bekommen. Laden Sie Teams zu bestimmten Projekten ein, setzen Sie Rollen und überschreiben Sie Funktionen und Limits pro Konto, damit Ihre Produktstufen zu Ihrer Abrechnung passen. Verkaufen Sie mehr Zugang, wenn Kunden wachsen — ohne individuelle Builds für jedes Paket.",
        agencies_screen_2_title: "Zugriff pro Kunde steuern",
        agencies_screen_3_badge: "KI",
        agencies_screen_3_bullets: [
            "Bieten Sie KI-Antworten an, die Ihren Kunden jede Woche Stunden speichern .",
            "Verbinden Sie Claude oder andere Assistenten über das MCP des jeweiligen Projekts.",
            "Produktisierung von KI als Premium-Add-on für Kunden"
        ],
        agencies_screen_3_subtitle: "Verwalten Sie nicht nur Bewertungen. Geben Sie Kunden KI, die Antworten entwirft, Feedback taggt und über Claude oder andere Assistenten über ihren Projekt-MCP-Server arbeitet. Das ist eine moderne Fähigkeit, die Agenturen paketieren, upselllen und erneuern können — ohne ein Content-Team für jedes Konto.",
        agencies_screen_3_title: "KI, für die Kunden zahlen",
        agencies_screen_4_badge: "Skala",
        agencies_screen_4_bullets: [
            "Verwalten Sie Bewertungen für viele Unternehmen über ein einziges Konto.",
            "Fügen Sie weitere Standorte hinzu, sobald Sie diese gewinnen, mit Mengenrabatt.",
            "Jeden Neukunden in einen Stammkunden verwandeln"
        ],
        agencies_screen_4_subtitle: "Ein Agentur-Sitz. Dutzende Unternehmen. Führen Sie Bewertungserfassung, Antworten und Reporting über jeden Kundenstandort von einem Hub aus und steigern Sie die Marge, wenn Sie Konten hinzufügen. So machen Agenturen Reputation zu einem skalierbaren Umsatzstrom, nicht zu einem einmaligen Projekt.",
        agencies_screen_4_title: "Skalieren Sie über jeden Kunden hinweg",
        agencies_summary_10_desc: "Verbinden Sie Claude oder andere Assistenten mit der Verwaltung von Projekten, Kunden und Teams.",
        agencies_summary_10_title: "Agentur MCP",
        agencies_summary_11_desc: "Jeder Kunde erhält das komplette Bewertungstoolkit: Sammlung, KI, Widgets und mehr.",
        agencies_summary_11_title: "Alles rund ums Geschäft",
        agencies_summary_12_desc: "Lassen Sie sich von einem Team unterstützen, das Agenturabläufe und die Einführung bei Kunden versteht.",
        agencies_summary_12_title: "Engagierter Support",
        agencies_summary_1_desc: "Clients verwalten ihre Reputation in einem Portal, das wie ein von Ihnen entwickeltes Produkt aussieht.",
        agencies_summary_1_title: "Markeneigenes Kundenportal",
        agencies_summary_2_desc: "Betreiben Sie das Portal auf Ihrer Domain, damit jeder Login mit Ihrer Marke in Verbindung gebracht wird.",
        agencies_summary_2_title: "Kundenagenturbereich",
        agencies_summary_3_desc: "Ermöglichen Sie Ihren Kunden die Anmeldung bei Ihrem Identitätsanbieter mit nur einem Klick.",
        agencies_summary_3_title: "Single Sign-On",
        agencies_summary_4_desc: "Laden Sie Kunden zu bestimmten Projekten ein und kontrollieren Sie, was sie sehen können.",
        agencies_summary_4_title: "Client & Rollen",
        agencies_summary_5_desc: "Limit-Anforderungen, Standorte und Funktionen pro Projekt, abgestimmt auf Ihre Pakete.",
        agencies_summary_5_title: "Projektbezogene Überschreibungen",
        agencies_summary_6_desc: "Gewähren Sie Ihrem internen Team vollen Zugriff auf alle Kundenprojekte.",
        agencies_summary_6_title: "Sitze im Agenturteam",
        agencies_summary_7_desc: "Beginnen Sie mit 5 Standorten und erweitern Sie Ihr Angebot mit Mengenrabatten, wenn Sie wachsen.",
        agencies_summary_7_title: "Maßstab für mehrere Standorte",
        agencies_summary_8_desc: "Systembenachrichtigungen werden von Ihrer Agenturdomain aus und projektbezogen versendet, wenn Kunden keine eigene Domain hinzugefügt haben.",
        agencies_summary_8_title: "White-Label-Versand",
        agencies_summary_9_desc: "Automatisieren Sie Projekte, Kunden und Teams mit der Agency API.",
        agencies_summary_9_title: "Agentur- API",
        demo_footer: "Wählen Sie einen Termin, der Ihnen passt. Wir führen Sie durch alles und beantworten Ihre Fragen.",
        desc_contact: "Haben Sie eine Frage oder brauchen Sie Hilfe? Senden Sie uns unten eine Nachricht — wir kümmern uns darum.",
        mcp_aria: "KI-Assistenten-Demo, verbunden mit More Good Reviews über MCP",
        mcp_prompts_aria: "Beispielhafte Eingabeaufforderungen",
        review_flow_aria: "Karussell mit E-Mail-Bewertungsanfragen, der Bewertungsseite, Google Bewertungen und privatem Feedback",
        review_flow_autopilot: "Läuft im Autopilotmodus",
        review_flow_card_email_desc: "Sobald Sie die Bearbeitung eines Kunden abgeschlossen haben, senden wir automatisch eine personalisierte E-Mail mit einer Anfrage und einem Link zu Ihrer Bewertungsseite, über den Sie mit einem Klick dorthin gelangen.",
        review_flow_card_email_title: "Senden Sie die Anfrage",
        review_flow_card_feedback_desc: "Bei niedrigeren Bewertungen wird zunächst ein privates Feedback-Formular angezeigt, damit Sie das Problem beheben können. Kunden können aber auch weiterhin eine öffentliche Bewertung abgeben.",
        review_flow_card_feedback_title: "Hartes Feedback einstecken",
        review_flow_card_google_desc: "Zufriedene Kunden erhalten einen einfachen Weg, eine öffentliche Google Bewertung abzugeben, sodass Lob genau dort erscheint, wo neue Kunden suchen.",
        review_flow_card_google_title: "Lob an Google senden",
        review_flow_card_review_desc: "Sie gelangen auf Ihre Bewertungsseite, geben eine Bewertung ab, und der nächste Schritt hängt davon ab, wie es gelaufen ist.",
        review_flow_card_review_title: "Der Kunde wählt eine Bewertung aus.",
        review_flow_next: "Nächster Schritt",
        review_flow_prev: "Vorheriger Schritt",
        review_flow_step_email: "Bewertung Anfrage",
        review_flow_step_feedback: "oder um Feedback bitten",
        review_flow_step_google: "Weg zu jeder Bewertung",
        review_flow_step_review: "Sternebewertung anfordern",
        review_flow_steps_aria: "Schritte der Anfrage Bewertung",
        summary_10_desc: "Organisieren Sie Kunden und Bewertungen , um schnell filtern und reagieren zu können.",
        summary_10_title: "Kunde und Bewertungskennzeichnung",
        summary_11_desc: "Zapier integriert More Good Reviews in die Tools, die Sie bereits verwenden.",
        summary_11_title: "Verbinde dich mit jeder beliebigen App",
        summary_12_desc: "Reputationsmanagement bei Claude, ChatGPT und anderen MCP Kunden.",
        summary_12_title: "MCP für KI-Assistenten",
        summary_1_desc: "Geplante E-Mail- und SMS Benachrichtigungen mit Erinnerungen, vollautomatisch.",
        summary_1_title: "Automatische Überprüfungsanfragen",
        summary_2_desc: "E-Mails und SMS , die zu Ihrer Marke, Ihrem Stil und Ihrem Angebot passen.",
        summary_2_title: "Markenvorlagen",
        summary_3_desc: "Sammeln Sie privates Feedback oder leiten Sie Nutzer an Google, Facebook und andere Plattformen weiter.",
        summary_3_title: "Bewertung",
        summary_4_desc: "Druckbare Codes und Vollbild-Abholung im Geschäft.",
        summary_4_title: "QR-Codes & Kiosk",
        summary_5_desc: "Binden Sie Bewertungen und Bewertungen an beliebiger Stelle auf Ihrer Website ein.",
        summary_5_title: "Website-Widgets",
        summary_6_desc: "Eine öffentliche, individuell gestaltbare Seite für Ihre besten Bewertungen.",
        summary_6_title: "Showcase Seite",
        summary_7_desc: "Bewertungen Importieren und von einem Ort aus antworten.",
        summary_7_title: "Google und Facebook-Synchronisierung",
        summary_8_desc: "Vorschläge auf der Seite, die Kunden beim Hinterlassen einer Bewertung unterstützen.",
        summary_8_title: "Hilfe beim Schreiben von KI-Rezensionen",
        summary_9_desc: "Entwürfe für Antworten, Zusammenfassungen, Trends und Fragen an die KI zu Ihren Bewertungen.",
        summary_9_title: "KI-Antworten und -Einblicke",
        subtitle_agencies_feature_summary: "White-Label-Portal, Kundenzugang, Skalierung und Automatisierung unter Ihrer Marke.",
        subtitle_ai_feature_summary: "Antworten, Tagging, Einblicke und Assistenten sind in Ihren Reputations-Workflow integriert.",
        subtitle_feature_summary: "Erfassung, Anzeige, KI und Integrationen — bereit, wenn Sie es sind.",
        subtitle_mcp: "Verbinden Sie Claude, ChatGPT und andere MCP-Clients und fragen Sie mit natürlicher Sprache nach Bewertungen, Standorten und Outreach.",
        subtitle_review_flow: "Fordern Sie automatisch Bewertungen an. Kunden können jederzeit eine öffentliche Bewertung abgeben. Privates Feedback ist optional.",
        title: "KI-Reputationsmanagement für",
        title_agencies: "Verwandeln Sie Bewertungen in",
        title_agencies_feature_summary: "Alles, was Agenturen brauchen",
        title_agencies_phrases: {
            branded_product: "ein Markenprodukt, das Ihnen gehört",
            recurring_retainers: "monatlich wiederkehrende Retainer",
            revenue_stream: "eine neue Einnahmequelle"
        },
        title_ai: "Frag deine KI",
        title_ai_feature_summary: "Alles, was KI für Sie tun kann",
        title_ai_phrases: {
            weekly_report: "für einen wöchentlichen Reputationsbericht",
            send_from_chat: "um Bewertungsanfragen zu versenden",
            next_steps: "für die nächsten Schritte"
        },
        title_contact: "Wie können wir helfen?",
        faq_location_pricing_a: "Beim Business-Tarif zahlen Sie pro Standort mit Mengenrabatt (ab 59 $\/Standort\/Monat bzw. 49 $\/Monat bei jährlicher Zahlung). Jeder Standort umfasst 5.000 Bewertungsanfragen pro Monat. Agency enthält 5 Standorte und 25.000 Anfragen; Extra-Standorte kosten 12 $\/Monat und bringen jeweils 5.000 weitere Anfragen.",
        faq_location_pricing_q: "Wie funktioniert die Standortpreisgestaltung?",
        title_faq: "Häufig gestellte Fragen",
        title_feature_summary: "Alles in einem Paket",
        title_footer: "Hören Sie auf, Bewertungen zu jagen. Fangen Sie an, sie zu bekommen.",
        title_footer_ai: "über Ihren Ruf",
        title_ltd: "Zahlen Sie einmal und nutzen Sie es für immer mit unserem zeitlich begrenzten Lifetime-Angebot.",
        title_mcp: "Fragen Sie die KI zu Ihrer Reputation",
        title_review_flow: "Verwandeln Sie großartige Erlebnisse in Bewertungen",
        title_phrases: {
            autopilot: "Bewertungen automatisch anzufordern",
            google_reviews: "mehr Google-Bewertungen zu erhalten",
            suggested_by_chatgpt: "von ChatGPT vorgeschlagen zu werden"
        },
        title_pricing: "Alle Funktionen. Einfache Preisgestaltung.",
        title_reviews: "Glauben Sie uns nicht einfach so"
    },
    plans: {
        additional_locations_tooltip: "Fügen Sie Standorte hinzu, wenn Sie wachsen. Business rechnet jeden Standort ab 59 $\/Monat ab (einschließlich des ersten), mit einem günstigeren Jahrespreis. Agency-Extras kosten 12 $\/Monat zusätzlich zu den 5 enthaltenen Standorten, und jeder Extra-Standort bringt 5.000 monatliche Anfragen.",
        agency: {
            agency_api: "Agentur- API",
            branded_portal: "Markeneigenes Kundenportal",
            client_invites: "Client , Rollen und Überschreibungen",
            custom_domain: "Kundenagenturbereich",
            everything_in_business: "Alles im Geschäftsplan",
            locations_included: "5 Standorte enthalten",
            review_requests: "5.000 Bewertungsanfragen pro Standort und Monat",
            sso: "Single Sign-On (SSO)",
            support: "Engagierter Kundensupport",
            volume_pricing: "Mengenrabatt ab 12 $\/Monat pro Extra-Standort"
        },
        business: {
            ai: "KI-Antworten, Einblicke & Fragen an die KI",
            api_mcp: "API und MCP Server",
            custom_domains: "Benutzerdefinierte E-Mail- und Bewertungsseiten-Domains",
            google_facebook: "Google Unternehmensprofil & Facebook",
            locations_included: "1 Standort enthalten",
            review_requests: "{count} Überprüfungsanfragen \/ Standort \/ Monat",
            support: "Engagierter Kundensupport",
            unlimited_customers: "Unbegrenzte Kunden",
            volume_pricing: "Mengenrabatt ab 59 $\/Monat"
        },
        descriptions: {
            agency: "Für Agenturen, die das Reputationsmanagement ihrer Kunden unter ihrer Marke übernehmen. Fünf Standorte inklusive, Extra-Standorte für 12 $, plus ein Markenportal und Kundenzugang.",
            business: "Für Unternehmen, die ihre Reputation selbst verwalten. Zahlen Sie pro Standort mit Mengenrabatten und erhalten Sie KI, Integrationen und eine unbegrenzte Kundenzahl inklusive."
        },
        selectors: {
            agency_extras_flat: "Zusätzliche Standorte · {price}\/{month} jeweils",
            agency_included: "{count} Standorte enthalten",
            agency_tier: "+{from}–{to} Positionen · {price}\/{month} jeweils",
            agency_tier_plus: "+{from}+ Standorte · {price}\/{month} jeweils",
            business_tier: "{from}–{to} Positionen · {price}\/{month} jeweils",
            business_tier_plus: "{from}+ Standorte · {price}\/{month} jeweils"
        }
    },
    mcp_example_prompts: {
        labels: {
            add_customer_and_ask: "Fügen Sie einen Kunden hinzu und fordern Sie eine Bewertung an.",
            customers_to_ask: "Finden Sie Kunden, die Sie um Bewertungen bitten können.",
            location_leaderboard: "Vergleich der Standortleistung",
            outreach_health: "Zustellqualität der Anfragen prüfen",
            review_digest: "Wöchentliche Zusammenfassung",
            send_review_requests: "Senden Sie Bewertungsanfragen in großen Mengen"
        },
        texts: {
            add_customer_and_ask: "Fügen Sie einen neuen Kunden anhand der von mir angegebenen Kontaktdaten hinzu und planen Sie anschließend eine Bewertungsanfrage per E-Mail mit 2 Erinnerungen.",
            customers_to_ask: "Erstellen Sie eine Liste mit bis zu 50 Kunden, die noch nie um eine Bewertung gebeten wurden, sortiert nach Anmeldedatum (neueste zuerst). Kunden, die sich abgemeldet haben, werden übersprungen. Die Liste soll Name, E-Mail-Adresse und Anmeldedatum enthalten.",
            import_customer: "Fügen Sie {name} als Kunden hinzu. Dessen E-Mail-Adresse lautet {email}.",
            import_customer_reply: "{name} hinzugefügt.",
            import_review: "Fügen Sie eine 5-Sterne-Bewertung von {name} hinzu: Das Team war professionell und die Ergebnisse waren hervorragend.",
            import_review_reply: "Die 5-Sterne-Bewertung von {name} wurde hinzugefügt.",
            location_leaderboard: "Erstellen Sie eine 90-Tage-Rangliste nach Standort mit Anzahl der Bewertungen, Durchschnittsbewertung, Anteil der 5-Sterne-Bewertungen und Trend im Vergleich zu den letzten 90 Tagen. Sortieren Sie nach Bewertung und kennzeichnen Sie jeden Rückgang von mehr als 0,2 Sternen.",
            outreach_health: "Für E-Mails, die in den letzten 14 Tagen versendet wurden, werden die Gesamtzahl der versendeten Nachrichten, die Zustellrate, die Öffnungsrate, die Klickrate und die Fehlerrate erfasst. Auffälligkeiten sind zu kennzeichnen.",
            review_digest: "Fassen Sie alle Bewertungen der letzten 7 Tage zusammen. Geben Sie die Anzahl, die durchschnittliche Bewertung, die Aufschlüsselung nach Quelle und Standort, die 3 wichtigsten Themen und die 3 größten Bedenken an.",
            send_review_requests: "Kunden, die sich in den letzten 30 Tagen angemeldet haben und noch nicht dazu aufgefordert wurden, können eine Bewertungsanfrage per E-Mail mit zwei Erinnerungen anfordern. Zuerst wird die Liste angezeigt, und ich warte auf meine Bestätigung."
        }
    },
    messages: {
        activated: "Erfolgreich aktiviert.",
        archived: "Erfolgreich archiviert.",
        canceled: "Erfolgreich abgebrochen.",
        cannot_copy: "Kopieren in die Zwischenablage nicht möglich",
        cname_active: "Der CNAME Status ist aktiv.",
        cname_not_active: "Der CNAME Status ist noch nicht aktiv.",
        connected: "Erfolgreich verbunden.",
        cookie_banner_text: "Wir verwenden Cookies, um Ihr Nutzererlebnis zu verbessern. Sie können Ihre Einstellungen anpassen oder alle akzeptieren.",
        cookie_category_analytics_desc: "Diese Cookies dienen der Messung des Website-Traffics und der Produktnutzung. Sie helfen uns zu verstehen, wie Besucher unsere Website nutzen.",
        cookie_category_essential_desc: "Immer aktiv. Diese Cookies sind für die Funktion der Website erforderlich und können nicht deaktiviert werden.",
        cookie_category_functional_desc: "Aktivieren Sie erweiterte Funktionen wie Live-Chat. Diese Cookies verfolgen Sie nicht zu Werbezwecken.",
        cookie_category_marketing_desc: "Wird für Werbung und Kampagnenmessung verwendet. Dazu können Werbepixel und Attributionstools gehören.",
        copied: "Erfolgreich kopiert.",
        copied_to_all_ratings: "Auf alle Bewertungen kopiert. Speichern, um anzuwenden.",
        created: "Erfolgreich erstellt.",
        deactivated: "Erfolgreich deaktiviert.",
        deleted: "Erfolgreich gelöscht.",
        disconnected: "Die Verbindung wurde erfolgreich getrennt.",
        duplicated: "Erfolgreich dupliziert.",
        error: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
        google_connect_failed: "Wir konnten keine Verbindung zu Google herstellen. Sie können es erneut versuchen oder diesen Schritt vorerst überspringen.",
        inquiry_sent: "Danke für Ihre Anfrage. Wir melden uns in Kürze.",
        oauth_consent_intro: "{client} bittet um Erlaubnis, auf Ihr Konto zuzugreifen.",
        oauth_request_missing: "Die OAuth-Autorisierungsanfrage fehlt oder ist abgelaufen.",
        operation_analytics_rebuild_failed: "Die Analyse konnte nicht erstellt werden.",
        operation_analytics_rebuild_progress: "Ihre Analyse wird erstellt…",
        operation_analytics_rebuild_success: "Die Analyse ist bereit.",
        operation_connection_sync_failed: "{integration_name}-Synchronisierung fehlgeschlagen.",
        operation_connection_sync_progress: "Synchronisierung von {integration_name}…",
        operation_connection_sync_success: "{integration_name}-Synchronisierung abgeschlossen.",
        operation_customer_import_failed: "Kunde fehlgeschlagen.",
        operation_customer_import_progress: "Importkunden…",
        operation_customer_import_success: "Kunde abgeschlossen.",
        operation_review_import_failed: "Der Import der Bewertung ist fehlgeschlagen.",
        operation_review_import_progress: "Bewertungen importieren …",
        operation_review_import_success: "Bewertung des Imports abgeschlossen.",
        operation_review_scrape_failed: "Der Import der letzten Rezension ist fehlgeschlagen.",
        operation_review_scrape_progress: "Aktuelle Bewertungen importieren …",
        operation_review_scrape_success: "Die kürzlich durchgeführte Überprüfung wurde erfolgreich importiert.",
        processed: "Erfolgreich verarbeitet.",
        published: "Erfolgreich veröffentlicht.",
        purchased: "Erfolgreich gekauft.",
        queued: "Erfolgreich geplant.",
        refreshed: "Erfolgreich aktualisiert.",
        removed: "Erfolgreich entfernt.",
        resubscribed: "Das erneute Abonnement war erfolgreich.",
        revoked: "Erfolgreich widerrufen.",
        saved: "Erfolgreich gespeichert.",
        scheduled: "Erfolgreich geplant.",
        sent: "Erfolgreich gesendet.",
        started: "Erfolgreich gestartet.",
        stopped: "Erfolgreich gestoppt.",
        sso_failed: "Autorisierung per SSO nicht möglich.",
        sso_invalid_callback: "Ungültiger SSO-Callback.",
        sso_not_configured: "SSO ist nicht konfiguriert.",
        sso_openid_config_failed: "OpenID-Konfiguration konnte nicht geladen werden.",
        sso_token_exchange_failed: "Der SSO-Token-Austausch konnte nicht abgeschlossen werden.",
        subscribed: "Erfolgreich abonniert.",
        suspended: "Erfolgreich suspendiert.",
        synced: "Erfolgreich synchronisiert.",
        unarchived: "Erfolgreich entarchiviert.",
        unpublished: "Erfolgreich unveröffentlicht.",
        unscheduled: "Erfolgreich aus dem Zeitplan entfernt.",
        unsubscribed: "Erfolgreich abgemeldet.",
        unsuspended: "Sperre erfolgreich aufgehoben.",
        updated: "Erfolgreich aktualisiert.",
        upgraded: "Upgrade erfolgreich durchgeführt.",
        validated: "Erfolgreich validiert.",
        verified: "Erfolgreich verifiziert."
    },
    notices: {
        agency: "Sie betreiben eine Agentur? Sie können unser Produkt als White-Label-Produkt verwenden, sodass Ihre Kunden bei der Nutzung des Dienstes nur Ihre Marke sehen.",
        ai_tags: "Erstellen Sie ein KI-Tag, damit passende Bewertungen automatisch markiert werden.",
        connected_apps: "Apps, die Sie über MCP verbinden, werden hier angezeigt.",
        connector: "Importieren Sie Ihre Kunden aus Tausenden von Anwendungen mit {brand}.",
        customer_messages: "Fordern Sie eine Bewertung an, um Nachrichten zu planen.",
        customer_reviews: "Fordern Sie eine Bewertung von diesem Kunden an.",
        customers: "Importieren Sie Ihre Kunden, um Bewertungen anzufordern.",
        customers_import_yourself: "Importieren Sie Ihre Kunden, um Bewertungen anzufordern. Sie können sich auch zuerst selbst importieren, um den Ablauf auszuprobieren, bevor Sie andere einladen.",
        external_links: "Fügen Sie Ihrem Kundenportal externe Links hinzu, um den Verkauf Ihrer Dienste zu unterstützen. Diese Links werden Ihren Kunden in der Seitenleiste angezeigt.",
        links: "Fügen Sie Ihrer Seite Schaltflächen hinzu, um Bewertungen auf Websites von Drittanbietern zu hinterlassen.",
        locations: "Erstellen Sie einen Standort, damit Sie Bewertungen mehreren Standorten zuordnen können.",
        ltd: "Lösen Sie 1 bis 5 Zugangscodes für dieses Konto ein (maximal 5). Jeder Code erhöht das monatliche Anforderungslimit und die Anzahl der verfügbaren Standorte auf 20. Die monatlichen Anforderungen ergeben sich aus der Summe aller eingelösten Codes. Drei oder mehr Codes schalten Agenturfunktionen frei. Geben Sie Ihre Codes unten durch Kommas getrennt ein.",
        mcp_example_prompts: "Sobald die Verbindung zum MCP Server hergestellt ist, fügen Sie diese als Ausgangspunkt in Ihren Assistenten ein.",
        messages: "Hier werden alle Anfragen und Erinnerungen angezeigt, wenn Ihre Kunden um Bewertungen gebeten werden.",
        no_commissions: "Sie haben bisher keine Provisionen verdient.",
        no_payouts: "Auszahlungen werden manuell veranlasst, sobald Ihr genehmigtes Guthaben mindestens 50,00 $ erreicht und Ihr Bankkonto verknüpft ist.",
        no_projects: "Ihnen wurde noch kein Projekt zugewiesen. Wenden Sie sich an Ihren Administrator, um Zugriff zu erhalten.",
        no_referrals: "Sie haben noch niemanden geworben. Teilen Sie Ihren Empfehlungslink, um loszulegen.",
        qr_codes: "Erstellen Sie QR-Codes mit individuellen Farben, Positionen und Tags. Download als SVG oder PNG.",
        referrals_share_subject: "Mein KI-Reputationsmanager",
        referrals_share_text: "Mein Geheimtipp für positive Bewertungen: More Good Reviews. KI-gestütztes Reputationsmanagement, das wirklich funktioniert. Melden Sie sich über meinen Link an:",
        review_pages: "Ihr Projekt kann mehrere Bewertungsseiten enthalten, auf denen Ihre Kunden Bewertungen hinterlassen können. Dies ist nützlich für Unternehmen mit mehr als einem Standort.",
        reviews: "Wir warten auf Bewertungen Ihrer Kunden.",
        showcase: "Wir fangen gerade erst an.",
        signatures: "Erstellen Sie eine E-Mail-Signatur zum Kopieren und Einfügen in Ihr E-Mail-Programm.",
        sources: "Erstellen Sie eine Quelle, damit Sie Ihre Bewertungen kategorisieren können.",
        tag_rules: "Erstellen Sie eine Regel, um Ihre Bewertungen automatisch mithilfe von KI zu kategorisieren.",
        tags: "Erstellen Sie ein Tag, um Ihre Bewertungen und Kunden zu kategorisieren.",
        unauthorized: "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.",
        unsubscribed: "Sie sind nun von Bewertungsanfragen abgemeldet.",
        webhooks: "Fügen Sie Webhooks hinzu, um über Plattformereignisse benachrichtigt zu werden.",
        widgets: "Erstellen Sie Widgets, um Bewertungen auf Ihrer Website einzubetten.",
        your_referral_link_text: "Teilen Sie Ihren Link und verdienen Sie {rate}% wiederkehrende Provision auf jede Zahlung von Kunden, die Sie geworben haben. Auszahlungen erfolgen manuell, sobald Ihr genehmigtes Guthaben mindestens 50,00 $ erreicht hat."
    },
    notification_types: {
        descriptions: {
            imports: "Wird versendet, sobald die Importe abgeschlossen sind",
            new_reviews: "Wird versendet, sobald Bewertungen eingegangen sind",
            sent_replies: "Wird gesendet, wenn Bewertungen automatisch beantwortet werden.",
            weekly_reports: "Eine wöchentliche Zusammenfassung der Aktivitäten wird versendet."
        },
        names: {
            imports: "Importe",
            new_reviews: "Neue Bewertungen",
            sent_replies: "Gesendete Antworten",
            weekly_reports: "Wöchentliche Berichte"
        }
    },
    roles: {
        admin: "Administrator",
        manager: "Manager",
        operator: "Operator",
        owner: "Eigentümer",
        super_admin: "Super-Administrator",
        viewer: "Zuschauer"
    },
    tasks: {
        automate: "Turn on automatic review requests and reminders. Each customer is contacted once, and can unsubscribe anytime.",
        customers: "Import customers with names and email or phone — manually, via Stripe, HubSpot, app connectors, the API, or by BCC’ing your project email on invoices.",
        google: "Connect Google Business Profile to import reviews, keep them in sync, and reply from here.",
        review_page: "Customize the page that captures reviews and can send customers to third-party sites — text, layout, fields, links, and redirects.",
        strategy: "Choose when customers are asked for reviews. We’ve set a simple default you can change anytime.",
        templates: "Edit the request and reminder emails customers receive. Both include one-click ratings, plus your logo and branding."
    },
    titles: {
        accept_invite: "Einladung annehmen",
        accepting_invite: "Einladung annehmen",
        access_denied: "Zugriff verweigert",
        account: "Konto",
        actions: "Aktionen",
        add_custom_field: "Benutzerdefiniertes Feld hinzufügen",
        add_ons: "Add-Ons",
        address: "Adresse",
        agencies: "Agenturen",
        agency: "Agentur",
        ai: "KI",
        ai_assistant: "KI-Assistent",
        ai_highlights: "KI-Highlights",
        ai_replies: "KI-Antworten",
        ai_review_suggestions: "Vorschläge zur KI- Bewertung",
        ai_tags: "KI-Tags",
        ai_tools: "KI-Tools",
        analytics: "Analyse",
        api: "API",
        api_key: "API Schlüssel",
        appearance: "Aussehen",
        application_connectors: "Anwendungskonnektoren",
        attributes: "Eigenschaften",
        authorize: "Autorisieren",
        auto_tagging: "Automatisches Tagging",
        automate: "Automatisieren",
        automatic_review_collection: "Automatische Bewertung",
        billing: "Abrechnung",
        branding: "Markenbildung",
        change_password: "Kennwort ändern",
        clients: "Clients",
        cname: "CNAME",
        conditions: "Bedingungen",
        confirmation_message: "Bestätigungsnachricht",
        connected_apps: "Verbundene Apps",
        contact_us: "Kontaktieren Sie uns",
        cookie_policy: "Cookie-Richtlinie",
        cookie_preferences: "Cookie-Einstellungen",
        copy: "Kopieren",
        create_your_account: "Erstellen Sie Ihr Konto",
        crms: "CRMs",
        css: "CSS",
        custom_field: "Benutzerdefiniertes Feld",
        custom_fields: "Benutzerdefinierte Felder",
        custom_icons: "Benutzerdefinierte Symbole",
        customer: "Kunde",
        customer_facing_pages: "Kundenseitige Seiten",
        customers: "Kunden",
        dashboard: "Übersichtsseite",
        details: "Details",
        dmarc: "DMARC",
        domain: "Domain",
        dpa: "Datenverarbeitungsvereinbarung",
        dsar: "Auskunftsersuchen der betroffenen Person",
        email_address: "E-Mail-Adresse",
        email_messages: "E-Mail-Nachrichten",
        email_settings: "E-Mail-Einstellungen",
        email_usage: "E-Mail-Nutzung",
        emails: "E-Mails",
        embed_code: "Code einbetten",
        example_chat: "Beispiel-Chat",
        examples: "Beispiele",
        export: "Export",
        external_link: "Externer Link",
        external_link_num: "Externer Link #{num}",
        external_links: "Externe Links",
        features: "Funktionen",
        feedback_form: "Feedback-Formular",
        field: "Feld",
        fields: "Felder",
        filters: "Filter",
        form_fields: "Formularfelder",
        got_access_code: "Haben Sie einen Zugangscode?",
        hipaa: "HIPAA-Erklärung",
        how_it_works: "Wie es funktioniert",
        incentive: "Anreiz",
        instructions: "Anweisungen",
        integration: "Integration",
        integrations: "Integrationen",
        javascript: "JavaScript",
        latest_reviews: "Neuste Bewertungen",
        location_leaderboard: "Standort-Rangliste",
        lifetime_deal: "Lebenslanges Angebot",
        lifetime_deal_terms: "Bedingungen für das lebenslange Angebot",
        limits: "Grenzen",
        link: "Link",
        links: "Links",
        location: "Standort",
        location_instructions: "Standortanweisungen",
        location_picker: "Standortauswahl",
        locations: "Standorte",
        log_in: "Einloggen",
        log_out: "Ausloggen",
        make_default: "Als Standard festlegen",
        manage_limits: "Limits verwalten",
        manage_overrides: "Außerkraftsetzungen verwalten",
        manage_review: "Bewertung verwalten",
        mcp_example_prompts: "Beispielhafte Eingabeaufforderungen",
        mcp_server: "MCP Server",
        message: "Nachricht",
        messages: "Nachrichten",
        meta: "Meta",
        no_clients: "Keine Clients",
        no_commissions: "Keine Provisionen",
        no_connected_apps: "Keine verbundenen Apps",
        no_custom_fields: "Keine benutzerdefinierten Felder",
        no_customers: "Keine Kunden",
        no_links: "Keine Links",
        no_locations: "Keine Standorte",
        no_members: "Keine Mitglieder",
        needs_attention: "Handlungsbedarf",
        no_messages: "Keine Nachrichten",
        no_payouts: "Keine Auszahlungen",
        no_projects: "Keine Projekte",
        no_qr_codes: "Keine QR-Codes",
        no_referrals: "Keine Empfehlungen",
        no_review_pages: "Keine Bewertungsseiten",
        no_reviews: "Keine Bewertungen",
        no_tags: "Keine Tags",
        no_team_members: "Keine Teammitglieder",
        no_template: "Keine Vorlage",
        no_widgets: "Keine Widgets",
        notifications: "Benachrichtigungen",
        options: "Optionen",
        overview: "Überblick",
        payment_method: "Zahlungsmethode",
        photo: "Foto",
        plans: "Tarife",
        powered_by: "Angetrieben von",
        pricing: "Preise",
        privacy_policy: "Datenschutzrichtlinie",
        profile: "Profil",
        project: "Projekt",
        project_limits: "Projektgrenzen",
        project_overrides: "Projektüberschreibungen",
        projects: "Projekte",
        qr_code: "QR-Code",
        qr_codes: "QR-Codes",
        ratings: "Sternebewertung",
        redeem_access_code: "Zugangscode einlösen",
        redirecting: "Umleitung",
        redirects: "Weiterleitungen",
        referrals_commissions: "Provisionen",
        referrals_payouts: "Auszahlungen",
        referral_program: "Bedingungen des Empfehlungsprogramms",
        reminders: "Erinnerungen",
        reply: "Antwort",
        request: "Anfrage",
        request_options: "Anfrageoptionen",
        requests: "Anfragen",
        required: "Erforderlich",
        reschedule_message: "Nachricht zur Terminverschiebung",
        reset_password: "Passwort zurücksetzen",
        resource_limits: "Ressourcenlimits",
        retries: "Wiederholungsversuche",
        review: "Bewertung",
        review_link: "Link zur Bewertung",
        review_page: "Bewertungsseite",
        review_pages: "Bewertungsseiten",
        review_spotlight: "Bewertungs-Spotlight",
        review_suggestions: "Bewertungsvorschläge",
        review_wall: "Bewertungswand",
        review_velocity: "Bewertungen pro Woche",
        reviewer: "Rezensent",
        reviews: "Bewertungen",
        save_changes: "Änderungen Speichern",
        schedule: "Zeitplan",
        scrape_a_website: "Website scrapen",
        search_engines: "Suchmaschinen",
        sections: "Abschnitte",
        select_csv_file: "CSV -Datei auswählen",
        select_project: "Projekt auswählen",
        selecting_project: "Projekt auswählen",
        sending_domain: "Absenderdomäne",
        sending_limits: "Sendelimits",
        sentiment: "Stimmung",
        settings: "Einstellungen",
        setup: "Einrichtung",
        setup_basics: "Ihre Anfrage",
        setup_business: "Los geht’s",
        setup_google: "Ihr Google Unternehmensprofil",
        setup_trusted: "Mehr als 5.000 Unternehmen vertrauen uns.",
        showcase: "Showcase",
        sign_up: "Melden Sie sich an",
        signature: "Signatur",
        signatures: "Signaturen",
        signing_in: "Anmelden",
        single_sign_on: "Single Sign-On",
        slug: "Slug",
        sms: "SMS",
        sms_messages: "SMS Nachrichten",
        sms_usage: "SMS Nutzung",
        smtp_configuration: "SMTP Konfiguration",
        source: "Quelle",
        sources: "Quellen",
        star_mix: "Bewertungsaufschlüsselung",
        space: "Arbeitsbereich",
        spaces: "Arbeitsbereiche",
        stats: "Statistiken",
        sub_processors: "Subprozessoren",
        success_page: "Erfolgsseite",
        summary: "Zusammenfassung",
        tag: "Tag",
        tag_rule: "Tag-Regel",
        tags: "Tags",
        team_members: "Teammitglieder",
        template: "Vorlage",
        templates: "Vorlagen",
        terms_of_service: "Servicebedingungen",
        two_factor_authentication: "Zwei-Faktor-Authentifizierung",
        unable_to_complete_request: "Anfrage konnte nicht abgeschlossen werden",
        unique_review_link: "Einzigartiger Bewertungslink",
        unsent_messages: "Nicht gesendete Nachrichten",
        unsubscribe: "Abbestellen",
        update_plan: "Aktualisierungsplan",
        usage: "Verwendung",
        user: "Benutzer",
        user_info: "Benutzerinformationen",
        verify_email_address: "E-Mail-Adresse bestätigen",
        verifying_email: "E-Mail bestätigen",
        visibility: "Sichtweite",
        webhook: "Webhook",
        webhooks: "Webhooks",
        website: "Webseite",
        white_label_api: "White-Label- API",
        white_label_client_portal: "White-Label-Client-Portal",
        white_label_image_urls: "White-Label-Bild-URLs",
        white_label_sending_domain: "White-Label-Sendedomäne",
        white_label_widget_tag: "White-Label-Widget-Tag",
        widget: "Widget",
        widget_num: "Widget #{num}",
        widgets: "Widgets",
        your_plan: "Ihr Plan"
    },
    tones: {
        apologetic: "Entschuldigend",
        casual: "Lässig",
        empathetic: "Einfühlsam",
        enthusiastic: "Enthusiastisch",
        formal: "Formell",
        friendly: "Freundlich",
        grateful: "Dankbar",
        humorous: "Humorvoll",
        informative: "Informativ"
    },
    widgets: {
        labels: {
            alignment: "Ausrichtung",
            animation: "Animation",
            autoplay: "Automatische Wiedergabe",
            autoplay_delay: "Autoplay-Verzögerung",
            avatar: "Avatar",
            background_color: "Hintergrundfarbe",
            border: "Grenze",
            border_color: "Rahmenfarbe",
            border_radius: "Randradius",
            border_width: "Rahmenbreite",
            carousel: "Karussell",
            colors: "Farben",
            company: "Unternehmen",
            customer: "Kunde",
            customer_position: "Kundenposition",
            date: "Datum",
            delay: "Verzögerung",
            design: "Design",
            design_prompt_placeholder: "Beispiel: Sanft und minimalistisch, mit goldenen Sternen und abgerundeten Ecken.",
            drop_shadow: "Schlagschatten",
            duration: "Dauer",
            filters: "Filter",
            font: "Schriftart",
            font_emphasis: "Schriftart Hervorhebung",
            font_family: "Schriftfamilie",
            font_size: "Schriftgröße",
            include_hidden: "Versteckte Bewertungen einschließen",
            layout: "Layout",
            limit: "Bewertungen pro Seite",
            location_ids: "Standorte",
            marquee: "Marquee",
            max_slides: "Max Folien",
            max_width: "Max. Breite",
            name_convention: "Name",
            padding: "Innenabstand",
            pagination: "Pagination",
            quotes: "Zitate",
            rating: "Sternebewertung",
            rating_round: "Runden",
            rating_round_hundredth: "Auf Hundertstel gerundet (4,94)",
            rating_round_tenth: "Auf die nächste Zehntelstelle gerundet (4,9)",
            review: "Bewertung",
            review_chars: "Länge der Bewertung",
            review_count: "Anzahl der Bewertung",
            review_id: "Bewertung",
            review_ids: "Bewertungen",
            review_ids_for_faces: "Bewertungen für Faces",
            reviews: "Bewertungen",
            schema: "Schema",
            schema_aggregate_only: "Nur Sternebewertung",
            schema_group_automotive: "Automobil",
            schema_group_food: "Essen",
            schema_group_health: "Gesundheit und Schönheit",
            schema_group_home: "Haus und Bau",
            schema_group_lodging: "Unterkunft",
            schema_group_medical: "Medizinisch",
            schema_group_other: "Andere",
            schema_group_professional: "Professional",
            schema_group_retail: "Einzelhandel",
            schema_id: "Schema ID",
            schema_id_info: "Gleichen Sie die @id mit dem bestehenden Geschäftsschema dieser Website ab, damit Google die Bewertung in diese Entität einbindet.",
            schema_name: "Firmenname",
            schema_type: "Unternehmenstätigkeit",
            score: "Niedrigste Bewertung",
            show_on_mobile: "Auf Mobilgeräten anzeigen",
            slider: "Schieberegler",
            sort: "Sortieren",
            source: "Quelle",
            source_ids: "Quellen",
            source_position: "Quellenposition",
            speed: "Geschwindigkeit",
            star_color: "Sternfarbe",
            star_display: "Sternendisplay",
            star_size: "Sterngröße",
            star_spacing: "Star Spacing",
            star_style: "Star Style",
            star_style_classic: "Classic",
            star_style_sharp: "Sharp",
            tag_ids: "Tags",
            take: "Maximale Anzahl an Bewertungen",
            text_color: "Textfarbe",
            truncate: "Bewertung verkürzen",
            visible_slides: "Sichtbare Folien",
            width: "Breite"
        },
        types: {
            badge: "Abzeichen",
            carousel: "Karussell",
            carousel_dynamic: "Dynamisches Karussell",
            corner: "Ecke",
            corner_dynamic: "Dynamische Ecke",
            faces: "Gesichter",
            headline: "Überschrift",
            highlights: "Highlights",
            marquee: "Marquee",
            spotlight: "Spotlight",
            wall: "Wand"
        }
    }
}